/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

export interface IClient {

    /**
     * @return Success
     */
    getAllAlarms(): Promise<AlarmDto[]>;

    /**
     * @return Success
     */
    getTimeAlarm(id: number): Promise<TimeAlarmDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimeAlarm(id: number, body: TimeAlarmDto | undefined): Promise<TimeAlarmDto>;

    /**
     * @return Success
     */
    getKmAlarm(id: number): Promise<KmAlarmDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKmAlarm(id: number, body: KmAlarmDto | undefined): Promise<KmAlarmDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addTimeAlarm(body: TimeAlarmDto | undefined): Promise<TimeAlarmDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addKmAlarm(body: KmAlarmDto | undefined): Promise<KmAlarmDto>;

    /**
     * @return Success
     */
    deleteAlarm(id: number): Promise<void>;

    /**
     * @return Success
     */
    getAllArmTemplates(): Promise<ArmModelDto[]>;

    /**
     * @return Success
     */
    getArmTemplate(armModelId: number): Promise<ArmModelDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmTemplate(armModelId: number, body: ArmModelDto | undefined): Promise<ArmModelDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmTemplate(armModelId: number, body: ArmModelDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmTemplate(body: ArmModelDto | undefined): Promise<ArmModelDto>;

    /**
     * @param clientId (optional) 
     * @param projectId (optional) 
     * @param conSiteID (optional) 
     * @param status (optional) 
     * @param dateFrom (optional) 
     * @return Success
     */
    getArmOrders(clientId: number | undefined, projectId: number | undefined, conSiteID: number | undefined, status: ArmOrderStatus | undefined, dateFrom: Date | undefined): Promise<ArmOrderDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmOrder(body: ArmOrderDto | undefined): Promise<ArmOrderDto>;

    /**
     * @return Success
     */
    getArmOrderById(armOrderId: number): Promise<ArmOrderDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmOrder(orderId: number, body: ArmOrderDto | undefined): Promise<ArmOrderDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmOrder(orderId: number, body: ArmOrderDto | undefined): Promise<void>;

    /**
     * @return Success
     */
    getArmOrderItems(orderId: number): Promise<ArmOrderItemDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmOrderItem(orderId: number, body: ArmOrderItemDto | undefined): Promise<ArmOrderItemDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmOrderItem(orderItemId: number, body: ArmOrderItemDto | undefined): Promise<ArmOrderItemDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmOrderItem(orderItemId: number, body: ArmOrderItemDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createArmCard(orderItemId: number, body: CreateArmCardRequestDto | undefined): Promise<ArmCardDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelArmCard(armCardId: number, body: CreateArmCardRequestDto | undefined): Promise<ArmCardDto>;

    /**
     * @return Success
     */
    getOrderProductionDataRefreshInfo(armOrderId: number): Promise<GetProductionDataRefreshInfoResponseDto>;

    /**
     * @return Success
     */
    getOrderProductionData(armOrderId: number): Promise<ArmOrderProductionDetailDataDto>;

    /**
     * @return Success
     */
    getOrderProductionDataVNext(armOrderId: number): Promise<ArmOrderProductionDetailDataDto>;

    /**
     * @return Success
     */
    getProductionDataRefreshInfo(): Promise<GetProductionDataRefreshInfoResponseDto>;

    /**
     * @return Success
     */
    getProductionData(): Promise<ArmProductionDetailDataDto>;

    /**
     * @param whatIf (optional) 
     * @param body (optional) 
     * @return Success
     */
    executeAction(whatIf: boolean | undefined, body: ExecuteActionRequestDto | undefined): Promise<ExecuteActionResponseDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    executeActionManual(orderItemId: number, actionTypeToDo: ArmatureActionType, body: ExecuteActionRequestDto | undefined): Promise<ExecuteActionResponseDto>;

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getItemsCreatedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsCreatedStatsResultDto>;

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getCardsCreatedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmCardsCreatedStatsResultDto>;

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmActionsExecutedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmActionsExecutedStatsResultDto>;

    /**
     * @param employeeId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmItemsFinishedByWorkerStats(employeeId: number | undefined, dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsFinishedByWorkerResultDto>;

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmItemsFinishedByWorkerReport(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsFinishedByWorkerResultDto>;

    /**
     * @param clientId (optional) 
     * @param projId (optional) 
     * @param conSiteId (optional) 
     * @return Success
     */
    getArmOrdersForClient(clientId: number | undefined, projId: number | undefined, conSiteId: number | undefined): Promise<ArmOrderDto[]>;

    /**
     * @return Success
     */
    getAllCustomers(): Promise<ClientDto[]>;

    /**
     * @return Success
     */
    getAllSupliers(): Promise<ClientDto[]>;

    /**
     * @return Success
     */
    getAllServices(): Promise<ClientDto[]>;

    /**
     * @return Success
     */
    getClientById(id: number): Promise<ClientDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClient(id: number, body: ClientDto | undefined): Promise<ClientDto>;

    /**
     * @return Success
     */
    getClientByShortName(shortName: string): Promise<ClientDto>;

    /**
     * @param searchToken (optional) 
     * @return Success
     */
    getCustomerBySearchToken(searchToken: string | undefined): Promise<ClientDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewClient(body: ClientDto | undefined): Promise<ClientDto>;

    /**
     * @return Success
     */
    deleteClient(id: number): Promise<void>;

    /**
     * @return Success
     */
    getClientDocuments(id: number, category: string): Promise<ClientDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveClientDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto>;

    /**
     * @return Success
     */
    deleteClientDocument(clientId: number, documentId: number): Promise<void>;

    /**
     * @param searchText (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllProjectsForClient(clientId: number, searchText: string | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<ProjectDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewInvoice(clientId: number, body: InvoiceDto | undefined): Promise<InvoiceDto>;

    /**
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllInvoicesForClient(clientId: number, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<InvoiceDto[]>;

    /**
     * @param recentlyUsed (optional) 
     * @return Success
     */
    getAllCompositions(recentlyUsed: boolean | undefined): Promise<CompositionDto[]>;

    /**
     * @return Success
     */
    getComposition(id: number): Promise<CompositionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteComposition(id: number, body: CompositionDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrGetComposition(body: CompositionDto | undefined): Promise<CompositionDto>;

    /**
     * @return Success
     */
    getConfig(): Promise<ConfigDto>;

    /**
     * @return Success
     */
    getAllDrivers(): Promise<DriverDto[]>;

    /**
     * @return Success
     */
    getDriver(id: number): Promise<DriverDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDriver(id: number, body: DriverDto | undefined): Promise<DriverDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDriver(id: number, body: DriverDto | undefined): Promise<void>;

    /**
     * @param name (optional) 
     * @return Success
     */
    getDriverByName(name: string | undefined): Promise<DriverDto>;

    /**
     * @param azObjId (optional) 
     * @return Success
     */
    getDriverByAzObjId(azObjId: string | undefined): Promise<DriverDto>;

    /**
     * @return Success
     */
    getDriverByJobPositionId(id: number): Promise<DriverDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewDriver(body: DriverDto | undefined): Promise<DriverDto>;

    /**
     * @return Success
     */
    getDriverDocuments(id: number, category: string): Promise<EmployeeDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveDriverDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto>;

    /**
     * @return Success
     */
    deleteDriverDocument(id: number, documentId: number): Promise<void>;

    /**
     * @param onlyFinished (optional) 
     * @param clientId (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getDriverTransportWarrants(id: number, onlyFinished: boolean | undefined, clientId: number | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<TransportWarrantDto[]>;

    /**
     * @return Success
     */
    getDriverAlarms(id: number): Promise<AlarmDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: EmployeeAccountDto | undefined): Promise<AuthenticatedDto>;

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]>;

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @return Success
     */
    deleteEmployee(id: number): Promise<void>;

    /**
     * @param type (optional) 
     * @return Success
     */
    getEmployees(type: JobPositionType | undefined): Promise<EmployeeDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto>;

    /**
     * @return Success
     */
    getEmployeeDocuments(id: number, category: string): Promise<EmployeeDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveEmployeeDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto>;

    /**
     * @return Success
     */
    deleteEmployeeDocument(id: number, documentId: number): Promise<void>;

    /**
     * @return Success
     */
    getEmployeeAccount(employeeId: number): Promise<EmployeeAccountDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployeeAccountPassword(accId: number, body: ChangePasswordDto | undefined): Promise<EmployeeAccountDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeContactInfo(employeeId: number, body: EmployeeContactInfoDto | undefined): Promise<EmployeeContactInfoDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeAccount(body: EmployeeAccountDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserName(body: EmployeeAccountDto | undefined): Promise<boolean>;

    /**
     * @return Success
     */
    getEmployeeJobPositions(employeeId: number): Promise<JobPositionDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto>;

    /**
     * @return Success
     */
    getSingleEmployeeUserGroup(id: number): Promise<UserGroupDto>;

    /**
     * @return Success
     */
    getAllEmployeeUserGroups(id: number): Promise<UserGroupDto[]>;

    /**
     * @param notificationMedia (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllEmployeeNotifications(id: number, notificationMedia: NotificationMedia | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<NotificationDto[]>;

    /**
     * @param notificationMedia (optional) 
     * @return Success
     */
    getAllEmployeeTimeEvents(id: number, notificationMedia: NotificationMedia | undefined): Promise<TimeEventDto[]>;

    /**
     * @param notificationMedia (optional) 
     * @return Success
     */
    getAllEmployeeKmEvents(id: number, notificationMedia: NotificationMedia | undefined): Promise<KmEventDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addTimeEvent(body: TimeEventDto | undefined): Promise<TimeEventDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addKmEvent(body: KmEventDto | undefined): Promise<KmEventDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimeEvent(id: number, body: TimeEventDto | undefined): Promise<TimeEventDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKmEvent(id: number, body: KmEventDto | undefined): Promise<KmEventDto>;

    /**
     * @return Success
     */
    checkForValidEvents(): Promise<void>;

    /**
     * @return Success
     */
    deleteEvent(id: number): Promise<void>;

    /**
     * @return Success
     */
    getInvoice(id: number): Promise<InvoiceDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvoice(id: number, body: InvoiceDto | undefined): Promise<InvoiceDto>;

    /**
     * @return Success
     */
    deleteInvoice(id: number): Promise<void>;

    /**
     * @return Success
     */
    getInvoiceByCode(code: string): Promise<InvoiceDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateJobPosition(id: number, body: JobPositionDto | undefined): Promise<JobPositionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNotification(body: NotificationDto | undefined): Promise<NotificationDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotification(id: number, body: NotificationDto | undefined): Promise<NotificationDto>;

    /**
     * @param includeConstructionSites (optional) 
     * @return Success
     */
    getProject(id: number, includeConstructionSites: boolean | undefined): Promise<ProjectDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProject(id: number, body: ProjectDto | undefined): Promise<ProjectDto>;

    /**
     * @return Success
     */
    deleteProject(id: number): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewProject(body: ProjectDto | undefined): Promise<ProjectDto>;

    /**
     * @param includeProject (optional) 
     * @return Success
     */
    getConstructionSite(id: number, includeProject: boolean | undefined): Promise<ConstructionSiteDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConstructionSite(id: number, body: ConstructionSiteDto | undefined): Promise<ConstructionSiteDto>;

    /**
     * @return Success
     */
    deleteConstructionSite(id: number): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewConstructionSite(body: ConstructionSiteDto | undefined): Promise<ConstructionSiteDto>;

    /**
     * @return Success
     */
    getAllConstructionSitesForProject(projectId: number): Promise<ConstructionSiteDto[]>;

    /**
     * @return Success
     */
    getRecordDocuments(recordId: number, category: string): Promise<RecordDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveRecordDocument(recordId: number, category: string, files: FileParameter[] | undefined, data: string | undefined): Promise<RecordDocumentDto>;

    /**
     * @return Success
     */
    sendUploadMediaRequest(recordId: number, category: string): Promise<void>;

    /**
     * @return Success
     */
    deleteRecordDocument(recordId: number, documentId: number): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeRecord(id: number, body: EmployeeRecordDto | undefined): Promise<EmployeeRecordDto>;

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllEmployeeRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<EmployeeRecordDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployeeRecord(id: number, body: EmployeeRecordDto | undefined): Promise<EmployeeRecordDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewVehicleRecord(vehicleId: number, body: VehicleRecordDto | undefined): Promise<VehicleRecordDto>;

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllVehicleRecords(vehicleId: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<VehicleRecordDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVehicleRecord(recordId: number, body: VehicleRecordDto | undefined): Promise<VehicleRecordDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteVehicleRecord(recordId: number, body: VehicleRecordDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteVehicleExpense(expenseId: number, body: VehicleExpenseDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewVehicleExpense(id: number, body: VehicleExpenseDto | undefined): Promise<VehicleExpenseDto>;

    /**
     * @param expenseCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllVehicleExpenses(id: number, expenseCategory: ExpenseCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<VehicleExpenseDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVehicleExpense(id: number, body: VehicleExpenseDto | undefined): Promise<VehicleExpenseDto>;

    /**
     * @param middleDate (optional) 
     * @param sumType (optional) 
     * @param expenseCategory (optional) 
     * @param id (optional) 
     * @param isKmExpense (optional) 
     * @return Success
     */
    getAllVehicleExpensesSums(middleDate: Date | undefined, sumType: SumType | undefined, expenseCategory: ExpenseCategory | undefined, id: number | undefined, isKmExpense: boolean | undefined): Promise<SumsDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingToolRecord(id: number, body: WorkingToolRecordDto | undefined): Promise<WorkingToolRecordDto>;

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllWorkingToolRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<WorkingToolRecordDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingToolRecord(id: number, body: WorkingToolRecordDto | undefined): Promise<WorkingToolRecordDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingToolExpense(id: number, body: WorkingToolExpenseDto | undefined): Promise<WorkingToolExpenseDto>;

    /**
     * @param expenseCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllWorkingToolExpenses(id: number, expenseCategory: ExpenseCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<WorkingToolExpenseDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingToolExpense(id: number, body: WorkingToolExpenseDto | undefined): Promise<WorkingToolExpenseDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWorkingToolRecord(recordId: number, body: WorkingToolRecordDto | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWorkingToolExpense(expenseId: number, body: WorkingToolExpenseDto | undefined): Promise<void>;

    /**
     * @param middleDate (optional) 
     * @param sumType (optional) 
     * @param expenseCategory (optional) 
     * @param id (optional) 
     * @param isKmExpense (optional) 
     * @return Success
     */
    getAllWorkingToolExpensesSums(middleDate: Date | undefined, sumType: SumType | undefined, expenseCategory: ExpenseCategory | undefined, id: number | undefined, isKmExpense: boolean | undefined): Promise<SumsDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewClientRecord(id: number, body: ClientRecordDto | undefined): Promise<ClientRecordDto>;

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllClientRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<ClientRecordDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientRecord(id: number, body: ClientRecordDto | undefined): Promise<ClientRecordDto>;

    /**
     * @param sumType (optional) 
     * @param endDate (optional) 
     * @param expenseCategory (optional) 
     * @return Success
     */
    getTruckPricePerKm(id: number, sumType: SumType | undefined, endDate: Date | undefined, expenseCategory: ExpenseCategory | undefined): Promise<SumsDto[]>;

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTruckFuelPricePerKm(id: number, startDate: Date | undefined, endDate: Date | undefined): Promise<FuelSumsDto[]>;

    /**
     * @param expenseCategory (optional) 
     * @return Success
     */
    getExpenseTypes(expenseCategory: ExpenseCategory | undefined): Promise<ExpenseTypeDto[]>;

    /**
     * @param name (optional) 
     * @return Success
     */
    getExpenseTypeByName(name: string | undefined): Promise<ExpenseTypeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addExpenseType(body: ExpenseTypeDto | undefined): Promise<ExpenseTypeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExpenseType(id: number, body: ExpenseTypeDto | undefined): Promise<ExpenseTypeDto>;

    /**
     * @return Success
     */
    getRecordAlarms(id: number): Promise<AlarmDto[]>;

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getActiveShipments(includeStops: boolean | undefined): Promise<ShipmentDto[]>;

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getAllShipments(includeStops: boolean | undefined): Promise<ShipmentDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewShipment(body: ShipmentDto | undefined): Promise<ShipmentDto>;

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getShipment(id: number, includeStops: boolean | undefined): Promise<ShipmentDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShipment(id: number, body: ShipmentDto | undefined): Promise<ShipmentDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteShipment(id: number, body: ShipmentDto | undefined): Promise<void>;

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getShipmentByName(title: string, includeStops: boolean | undefined): Promise<ShipmentDto>;

    /**
     * @return Success
     */
    getAllShipmentCustomers(): Promise<string[]>;

    /**
     * @return Success
     */
    getStop(id: number): Promise<StopDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStop(id: number, body: StopDto | undefined): Promise<StopDto>;

    /**
     * @return Success
     */
    deleteStop(id: number): Promise<void>;

    /**
     * @return Success
     */
    getAllStops(): Promise<StopDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewStop(body: StopDto | undefined): Promise<StopDto>;

    /**
     * @return Success
     */
    getStopByName(name: string): Promise<StopDto>;

    /**
     * @param name (optional) 
     * @return Success
     */
    getUserGroupByName(name: string | undefined): Promise<UserGroupDto>;

    /**
     * @return Success
     */
    getUserGroupById(id: number): Promise<UserGroupDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserGroup(body: UserGroupDto | undefined): Promise<UserGroupDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGroup(id: number, body: UserGroupDto | undefined): Promise<UserGroupDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserGroup(id: number, body: UserGroupDto | undefined): Promise<UserGroupDto>;

    /**
     * @return Success
     */
    getAllCars(): Promise<CarDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewCar(body: CarDto | undefined): Promise<CarDto>;

    /**
     * @return Success
     */
    getAllTrucks(): Promise<TruckDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTruck(body: TruckDto | undefined): Promise<TruckDto>;

    /**
     * @return Success
     */
    getAllTrailers(): Promise<TrailerDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTrailer(body: TrailerDto | undefined): Promise<TrailerDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrailer(id: number, body: TrailerDto | undefined): Promise<TrailerDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCar(id: number, body: CarDto | undefined): Promise<CarDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTruck(id: number, body: TruckDto | undefined): Promise<TruckDto>;

    /**
     * @param manufacturer (optional) 
     * @return Success
     */
    getModels(manufacturer: string | undefined): Promise<string[]>;

    /**
     * @return Success
     */
    getManufacturers(): Promise<string[]>;

    /**
     * @return Success
     */
    deleteVehicle(id: number): Promise<void>;

    /**
     * @return Success
     */
    getVehicle(id: number): Promise<VehicleDto>;

    /**
     * @return Success
     */
    getVehicleDocuments(id: number, category: string): Promise<VehicleDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveVehicleDocument(id: number, category: string, files: FileParameter[] | undefined, data: string | undefined): Promise<DocumentDto>;

    /**
     * @return Success
     */
    deleteVehiclesDocument(vehicleId: number, documentId: number): Promise<void>;

    /**
     * @param onlyFinished (optional) 
     * @param clientId (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getVehicleTransportWarrants(id: number, onlyFinished: boolean | undefined, clientId: number | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<TransportWarrantDto[]>;

    /**
     * @return Success
     */
    getCarTravelWarrants(id: number): Promise<TravelWarrantDto[]>;

    /**
     * @param lpNum (optional) 
     * @return Success
     */
    getVehicleByLicensePlateNum(lpNum: string | undefined): Promise<VehicleDto>;

    /**
     * @return Success
     */
    getVehicleAlarms(id: number): Promise<AlarmDto[]>;

    /**
     * @param currentDate (optional) 
     * @return Success
     */
    getLastKmForDate(id: number, currentDate: Date | undefined): Promise<number>;

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @return Success
     */
    getKmDifferenceForDates(id: number, startingDate: Date | undefined, endingDate: Date | undefined): Promise<number>;

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @return Success
     */
    getKmDifferenceForDates(id: number, startingDate: Date | undefined, endingDate: Date | undefined): Promise<number>;

    /**
     * @return Success
     */
    getVehicleExpenseByExpId(id: number): Promise<VehicleExpenseDto>;

    /**
     * @return Success
     */
    getVehicleRecordByRecId(id: number): Promise<VehicleRecordDto>;

    /**
     * @return Success
     */
    getNewSubscribedUsers(): Promise<EmployeeContactInfoDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTravelWarrant(body: TravelWarrantDto | undefined): Promise<TravelWarrantDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTravelWarrant(id: number, body: TravelWarrantDto | undefined): Promise<TravelWarrantDto>;

    /**
     * @return Success
     */
    deleteTravelWarrant(id: number): Promise<void>;

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @return Success
     */
    getTravelWarrantsForDateRange(startingDate: Date | undefined, endingDate: Date | undefined): Promise<TravelWarrantDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTransportWarrant(body: TransportWarrantDto | undefined): Promise<TransportWarrantDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransportWarrant(id: number, body: TransportWarrantDto | undefined): Promise<TransportWarrantDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTransportWarrant(id: number, body: TransportWarrantDto | undefined): Promise<void>;

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param includeTwItems (optional) 
     * @return Success
     */
    getTransportWarrantsForDateRange(startingDate: Date | undefined, endingDate: Date | undefined, includeTwItems: boolean | undefined): Promise<TransportWarrantDto[]>;

    /**
     * @param includeTwItems (optional) 
     * @return Success
     */
    getTransportWarrant(id: number, includeTwItems: boolean | undefined): Promise<TransportWarrantDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTransportWarrantItem(body: TransportWarrantItemDto | undefined): Promise<TransportWarrantItemDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransportWarrantItem(twiId: number, body: TransportWarrantItemDto | undefined): Promise<TransportWarrantItemDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTransportWarrantItem(twiId: number, body: TransportWarrantItemDto | undefined): Promise<void>;

    /**
     * @return Success
     */
    getTransportWarrantItems(twId: number): Promise<TransportWarrantItemDto[]>;

    /**
     * @return Success
     */
    getAllWorkingTools(): Promise<WorkingToolDto[]>;

    /**
     * @return Success
     */
    getAllWorkingMachines(): Promise<WorkingMachineDto[]>;

    /**
     * @return Success
     */
    getAllOfficeMachines(): Promise<WorkingMachineDto[]>;

    /**
     * @return Success
     */
    getAllHandMachines(): Promise<WorkingMachineDto[]>;

    /**
     * @return Success
     */
    getWorkingMachine(id: number): Promise<WorkingMachineDto>;

    /**
     * @return Success
     */
    getWorkingTool(id: number): Promise<WorkingToolDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingMachine(id: number, body: WorkingMachineDto | undefined): Promise<WorkingMachineDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingTool(body: WorkingToolDto | undefined): Promise<WorkingToolDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingMachine(body: WorkingMachineDto | undefined): Promise<WorkingMachineDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingTool(id: number, body: WorkingToolDto | undefined): Promise<WorkingToolDto>;

    /**
     * @return Success
     */
    deleteWorkingTool(id: number): Promise<void>;

    /**
     * @param manufacturer (optional) 
     * @return Success
     */
    getWorkingToolModels(manufacturer: string | undefined): Promise<string[]>;

    /**
     * @return Success
     */
    getWorkingToolManufacturers(): Promise<string[]>;

    /**
     * @return Success
     */
    getWorkingToolDocuments(id: number, category: string): Promise<WorkingToolDocumentDto[]>;

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveWorkingToolDocument(id: number, category: string, files: FileParameter[] | undefined, data: string | undefined): Promise<DocumentDto>;

    /**
     * @return Success
     */
    deleteWorkingToolsDocument(id: number, documentId: number): Promise<void>;

    /**
     * @return Success
     */
    getWorkingMachineAlarms(id: number): Promise<AlarmDto[]>;
}

export class Client implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAlarms(): Promise<AlarmDto[]> {
        let url_ = this.baseUrl + "/api/Alarm/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAlarms(_response);
        });
    }

    protected processGetAllAlarms(response: Response): Promise<AlarmDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTimeAlarm(id: number): Promise<TimeAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/time/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimeAlarm(_response);
        });
    }

    protected processGetTimeAlarm(response: Response): Promise<TimeAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeAlarmDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimeAlarm(id: number, body: TimeAlarmDto | undefined): Promise<TimeAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/time/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTimeAlarm(_response);
        });
    }

    protected processUpdateTimeAlarm(response: Response): Promise<TimeAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getKmAlarm(id: number): Promise<KmAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/km/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKmAlarm(_response);
        });
    }

    protected processGetKmAlarm(response: Response): Promise<KmAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KmAlarmDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKmAlarm(id: number, body: KmAlarmDto | undefined): Promise<KmAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/km/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateKmAlarm(_response);
        });
    }

    protected processUpdateKmAlarm(response: Response): Promise<KmAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTimeAlarm(body: TimeAlarmDto | undefined): Promise<TimeAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTimeAlarm(_response);
        });
    }

    protected processAddTimeAlarm(response: Response): Promise<TimeAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addKmAlarm(body: KmAlarmDto | undefined): Promise<KmAlarmDto> {
        let url_ = this.baseUrl + "/api/Alarm/km";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKmAlarm(_response);
        });
    }

    protected processAddKmAlarm(response: Response): Promise<KmAlarmDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmAlarmDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteAlarm(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Alarm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAlarm(_response);
        });
    }

    protected processDeleteAlarm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllArmTemplates(): Promise<ArmModelDto[]> {
        let url_ = this.baseUrl + "/api/Armature/templates/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllArmTemplates(_response);
        });
    }

    protected processGetAllArmTemplates(response: Response): Promise<ArmModelDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArmModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArmModelDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getArmTemplate(armModelId: number): Promise<ArmModelDto> {
        let url_ = this.baseUrl + "/api/Armature/templates/{armModelId}";
        if (armModelId === undefined || armModelId === null)
            throw new Error("The parameter 'armModelId' must be defined.");
        url_ = url_.replace("{armModelId}", encodeURIComponent("" + armModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmTemplate(_response);
        });
    }

    protected processGetArmTemplate(response: Response): Promise<ArmModelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmModelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArmModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmTemplate(armModelId: number, body: ArmModelDto | undefined): Promise<ArmModelDto> {
        let url_ = this.baseUrl + "/api/Armature/templates/{armModelId}";
        if (armModelId === undefined || armModelId === null)
            throw new Error("The parameter 'armModelId' must be defined.");
        url_ = url_.replace("{armModelId}", encodeURIComponent("" + armModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArmTemplate(_response);
        });
    }

    protected processUpdateArmTemplate(response: Response): Promise<ArmModelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmModelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmTemplate(armModelId: number, body: ArmModelDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Armature/templates/{armModelId}";
        if (armModelId === undefined || armModelId === null)
            throw new Error("The parameter 'armModelId' must be defined.");
        url_ = url_.replace("{armModelId}", encodeURIComponent("" + armModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArmTemplate(_response);
        });
    }

    protected processDeleteArmTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmTemplate(body: ArmModelDto | undefined): Promise<ArmModelDto> {
        let url_ = this.baseUrl + "/api/Armature/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddArmTemplate(_response);
        });
    }

    protected processAddArmTemplate(response: Response): Promise<ArmModelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmModelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param clientId (optional) 
     * @param projectId (optional) 
     * @param conSiteID (optional) 
     * @param status (optional) 
     * @param dateFrom (optional) 
     * @return Success
     */
    getArmOrders(clientId: number | undefined, projectId: number | undefined, conSiteID: number | undefined, status: ArmOrderStatus | undefined, dateFrom: Date | undefined): Promise<ArmOrderDto[]> {
        let url_ = this.baseUrl + "/api/Armature/orders?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (conSiteID === null)
            throw new Error("The parameter 'conSiteID' cannot be null.");
        else if (conSiteID !== undefined)
            url_ += "conSiteID=" + encodeURIComponent("" + conSiteID) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmOrders(_response);
        });
    }

    protected processGetArmOrders(response: Response): Promise<ArmOrderDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArmOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmOrder(body: ArmOrderDto | undefined): Promise<ArmOrderDto> {
        let url_ = this.baseUrl + "/api/Armature/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddArmOrder(_response);
        });
    }

    protected processAddArmOrder(response: Response): Promise<ArmOrderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getArmOrderById(armOrderId: number): Promise<ArmOrderDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{armOrderId}";
        if (armOrderId === undefined || armOrderId === null)
            throw new Error("The parameter 'armOrderId' must be defined.");
        url_ = url_.replace("{armOrderId}", encodeURIComponent("" + armOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmOrderById(_response);
        });
    }

    protected processGetArmOrderById(response: Response): Promise<ArmOrderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArmOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmOrder(orderId: number, body: ArmOrderDto | undefined): Promise<ArmOrderDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArmOrder(_response);
        });
    }

    protected processUpdateArmOrder(response: Response): Promise<ArmOrderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmOrder(orderId: number, body: ArmOrderDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Armature/orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArmOrder(_response);
        });
    }

    protected processDeleteArmOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getArmOrderItems(orderId: number): Promise<ArmOrderItemDto[]> {
        let url_ = this.baseUrl + "/api/Armature/orders/{orderId}/items";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmOrderItems(_response);
        });
    }

    protected processGetArmOrderItems(response: Response): Promise<ArmOrderItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArmOrderItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addArmOrderItem(orderId: number, body: ArmOrderItemDto | undefined): Promise<ArmOrderItemDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{orderId}/items";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddArmOrderItem(_response);
        });
    }

    protected processAddArmOrderItem(response: Response): Promise<ArmOrderItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArmOrderItem(orderItemId: number, body: ArmOrderItemDto | undefined): Promise<ArmOrderItemDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/items/{orderItemId}";
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArmOrderItem(_response);
        });
    }

    protected processUpdateArmOrderItem(response: Response): Promise<ArmOrderItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteArmOrderItem(orderItemId: number, body: ArmOrderItemDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Armature/orders/items/{orderItemId}";
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArmOrderItem(_response);
        });
    }

    protected processDeleteArmOrderItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createArmCard(orderItemId: number, body: CreateArmCardRequestDto | undefined): Promise<ArmCardDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/items/{orderItemId}/cards";
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateArmCard(_response);
        });
    }

    protected processCreateArmCard(response: Response): Promise<ArmCardDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmCardDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelArmCard(armCardId: number, body: CreateArmCardRequestDto | undefined): Promise<ArmCardDto> {
        let url_ = this.baseUrl + "/api/Armature/cards/{armCardId}/cancel";
        if (armCardId === undefined || armCardId === null)
            throw new Error("The parameter 'armCardId' must be defined.");
        url_ = url_.replace("{armCardId}", encodeURIComponent("" + armCardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelArmCard(_response);
        });
    }

    protected processCancelArmCard(response: Response): Promise<ArmCardDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmCardDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getOrderProductionDataRefreshInfo(armOrderId: number): Promise<GetProductionDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{armOrderId}/production/refreshInfo";
        if (armOrderId === undefined || armOrderId === null)
            throw new Error("The parameter 'armOrderId' must be defined.");
        url_ = url_.replace("{armOrderId}", encodeURIComponent("" + armOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrderProductionDataRefreshInfo(_response);
        });
    }

    protected processGetOrderProductionDataRefreshInfo(response: Response): Promise<GetProductionDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductionDataRefreshInfoResponseDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getOrderProductionData(armOrderId: number): Promise<ArmOrderProductionDetailDataDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{armOrderId}/production";
        if (armOrderId === undefined || armOrderId === null)
            throw new Error("The parameter 'armOrderId' must be defined.");
        url_ = url_.replace("{armOrderId}", encodeURIComponent("" + armOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrderProductionData(_response);
        });
    }

    protected processGetOrderProductionData(response: Response): Promise<ArmOrderProductionDetailDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderProductionDetailDataDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getOrderProductionDataVNext(armOrderId: number): Promise<ArmOrderProductionDetailDataDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/{armOrderId}/productionVNext";
        if (armOrderId === undefined || armOrderId === null)
            throw new Error("The parameter 'armOrderId' must be defined.");
        url_ = url_.replace("{armOrderId}", encodeURIComponent("" + armOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrderProductionDataVNext(_response);
        });
    }

    protected processGetOrderProductionDataVNext(response: Response): Promise<ArmOrderProductionDetailDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmOrderProductionDetailDataDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getProductionDataRefreshInfo(): Promise<GetProductionDataRefreshInfoResponseDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/production/refreshInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionDataRefreshInfo(_response);
        });
    }

    protected processGetProductionDataRefreshInfo(response: Response): Promise<GetProductionDataRefreshInfoResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductionDataRefreshInfoResponseDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getProductionData(): Promise<ArmProductionDetailDataDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/production";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionData(_response);
        });
    }

    protected processGetProductionData(response: Response): Promise<ArmProductionDetailDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmProductionDetailDataDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param whatIf (optional) 
     * @param body (optional) 
     * @return Success
     */
    executeAction(whatIf: boolean | undefined, body: ExecuteActionRequestDto | undefined): Promise<ExecuteActionResponseDto> {
        let url_ = this.baseUrl + "/api/Armature/actions?";
        if (whatIf === null)
            throw new Error("The parameter 'whatIf' cannot be null.");
        else if (whatIf !== undefined)
            url_ += "whatIf=" + encodeURIComponent("" + whatIf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExecuteAction(_response);
        });
    }

    protected processExecuteAction(response: Response): Promise<ExecuteActionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExecuteActionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeActionManual(orderItemId: number, actionTypeToDo: ArmatureActionType, body: ExecuteActionRequestDto | undefined): Promise<ExecuteActionResponseDto> {
        let url_ = this.baseUrl + "/api/Armature/orders/items/{orderItemId}/actions/{actionTypeToDo}";
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId));
        if (actionTypeToDo === undefined || actionTypeToDo === null)
            throw new Error("The parameter 'actionTypeToDo' must be defined.");
        url_ = url_.replace("{actionTypeToDo}", encodeURIComponent("" + actionTypeToDo));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExecuteActionManual(_response);
        });
    }

    protected processExecuteActionManual(response: Response): Promise<ExecuteActionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExecuteActionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getItemsCreatedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsCreatedStatsResultDto> {
        let url_ = this.baseUrl + "/api/Armature/OrderItemsCreatedStat?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (granulation === null)
            throw new Error("The parameter 'granulation' cannot be null.");
        else if (granulation !== undefined)
            url_ += "granulation=" + encodeURIComponent("" + granulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItemsCreatedStat(_response);
        });
    }

    protected processGetItemsCreatedStat(response: Response): Promise<ArmItemsCreatedStatsResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmItemsCreatedStatsResultDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getCardsCreatedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmCardsCreatedStatsResultDto> {
        let url_ = this.baseUrl + "/api/Armature/CardsCreatedStat?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (granulation === null)
            throw new Error("The parameter 'granulation' cannot be null.");
        else if (granulation !== undefined)
            url_ += "granulation=" + encodeURIComponent("" + granulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCardsCreatedStat(_response);
        });
    }

    protected processGetCardsCreatedStat(response: Response): Promise<ArmCardsCreatedStatsResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmCardsCreatedStatsResultDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmActionsExecutedStat(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmActionsExecutedStatsResultDto> {
        let url_ = this.baseUrl + "/api/Armature/GetArmActionsExecutedStat?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (granulation === null)
            throw new Error("The parameter 'granulation' cannot be null.");
        else if (granulation !== undefined)
            url_ += "granulation=" + encodeURIComponent("" + granulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmActionsExecutedStat(_response);
        });
    }

    protected processGetArmActionsExecutedStat(response: Response): Promise<ArmActionsExecutedStatsResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmActionsExecutedStatsResultDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param employeeId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmItemsFinishedByWorkerStats(employeeId: number | undefined, dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsFinishedByWorkerResultDto> {
        let url_ = this.baseUrl + "/api/Armature/GetArmItemsFinishedByWorkerStats?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (granulation === null)
            throw new Error("The parameter 'granulation' cannot be null.");
        else if (granulation !== undefined)
            url_ += "granulation=" + encodeURIComponent("" + granulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmItemsFinishedByWorkerStats(_response);
        });
    }

    protected processGetArmItemsFinishedByWorkerStats(response: Response): Promise<ArmItemsFinishedByWorkerResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmItemsFinishedByWorkerResultDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param granulation (optional) 
     * @return Success
     */
    getArmItemsFinishedByWorkerReport(dateFrom: Date | undefined, dateTo: Date | undefined, granulation: StatGranulation | undefined): Promise<ArmItemsFinishedByWorkerResultDto> {
        let url_ = this.baseUrl + "/api/Armature/GetArmItemsFinishedByWorkerReport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (granulation === null)
            throw new Error("The parameter 'granulation' cannot be null.");
        else if (granulation !== undefined)
            url_ += "granulation=" + encodeURIComponent("" + granulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmItemsFinishedByWorkerReport(_response);
        });
    }

    protected processGetArmItemsFinishedByWorkerReport(response: Response): Promise<ArmItemsFinishedByWorkerResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmItemsFinishedByWorkerResultDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param clientId (optional) 
     * @param projId (optional) 
     * @param conSiteId (optional) 
     * @return Success
     */
    getArmOrdersForClient(clientId: number | undefined, projId: number | undefined, conSiteId: number | undefined): Promise<ArmOrderDto[]> {
        let url_ = this.baseUrl + "/api/Armature/GetArmOrdersForClient?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (projId === null)
            throw new Error("The parameter 'projId' cannot be null.");
        else if (projId !== undefined)
            url_ += "projId=" + encodeURIComponent("" + projId) + "&";
        if (conSiteId === null)
            throw new Error("The parameter 'conSiteId' cannot be null.");
        else if (conSiteId !== undefined)
            url_ += "conSiteId=" + encodeURIComponent("" + conSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArmOrdersForClient(_response);
        });
    }

    protected processGetArmOrdersForClient(response: Response): Promise<ArmOrderDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArmOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllCustomers(): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/api/Client/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCustomers(_response);
        });
    }

    protected processGetAllCustomers(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllSupliers(): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/api/Client/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSupliers(_response);
        });
    }

    protected processGetAllSupliers(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllServices(): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/api/Client/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllServices(_response);
        });
    }

    protected processGetAllServices(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getClientById(id: number): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientById(_response);
        });
    }

    protected processGetClientById(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClient(id: number, body: ClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getClientByShortName(shortName: string): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client/shortname/{shortName}";
        if (shortName === undefined || shortName === null)
            throw new Error("The parameter 'shortName' must be defined.");
        url_ = url_.replace("{shortName}", encodeURIComponent("" + shortName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientByShortName(_response);
        });
    }

    protected processGetClientByShortName(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param searchToken (optional) 
     * @return Success
     */
    getCustomerBySearchToken(searchToken: string | undefined): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/api/Client/customers/search?";
        if (searchToken === null)
            throw new Error("The parameter 'searchToken' cannot be null.");
        else if (searchToken !== undefined)
            url_ += "searchToken=" + encodeURIComponent("" + searchToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerBySearchToken(_response);
        });
    }

    protected processGetCustomerBySearchToken(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewClient(body: ClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewClient(_response);
        });
    }

    protected processAddNewClient(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteClient(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Client/{id}/Delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getClientDocuments(id: number, category: string): Promise<ClientDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Client/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientDocuments(_response);
        });
    }

    protected processGetClientDocuments(response: Response): Promise<ClientDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveClientDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Client/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveClientDocument(_response);
        });
    }

    protected processSaveClientDocument(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteClientDocument(clientId: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/document/{documentId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteClientDocument(_response);
        });
    }

    protected processDeleteClientDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllProjectsForClient(clientId: number, searchText: string | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/projects?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProjectsForClient(_response);
        });
    }

    protected processGetAllProjectsForClient(response: Response): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewInvoice(clientId: number, body: InvoiceDto | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/invoice";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewInvoice(_response);
        });
    }

    protected processAddNewInvoice(response: Response): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllInvoicesForClient(clientId: number, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<InvoiceDto[]> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/invoices?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllInvoicesForClient(_response);
        });
    }

    protected processGetAllInvoicesForClient(response: Response): Promise<InvoiceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto[]>(null as any);
    }

    /**
     * @param recentlyUsed (optional) 
     * @return Success
     */
    getAllCompositions(recentlyUsed: boolean | undefined): Promise<CompositionDto[]> {
        let url_ = this.baseUrl + "/api/Composition/all?";
        if (recentlyUsed === null)
            throw new Error("The parameter 'recentlyUsed' cannot be null.");
        else if (recentlyUsed !== undefined)
            url_ += "recentlyUsed=" + encodeURIComponent("" + recentlyUsed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCompositions(_response);
        });
    }

    protected processGetAllCompositions(response: Response): Promise<CompositionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompositionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositionDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getComposition(id: number): Promise<CompositionDto> {
        let url_ = this.baseUrl + "/api/Composition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetComposition(_response);
        });
    }

    protected processGetComposition(response: Response): Promise<CompositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteComposition(id: number, body: CompositionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Composition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteComposition(_response);
        });
    }

    protected processDeleteComposition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrGetComposition(body: CompositionDto | undefined): Promise<CompositionDto> {
        let url_ = this.baseUrl + "/api/Composition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrGetComposition(_response);
        });
    }

    protected processCreateOrGetComposition(response: Response): Promise<CompositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getConfig(): Promise<ConfigDto> {
        let url_ = this.baseUrl + "/api/Config/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<ConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDrivers(): Promise<DriverDto[]> {
        let url_ = this.baseUrl + "/api/Driver/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDrivers(_response);
        });
    }

    protected processGetAllDrivers(response: Response): Promise<DriverDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DriverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDriver(id: number): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriver(_response);
        });
    }

    protected processGetDriver(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDriver(id: number, body: DriverDto | undefined): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDriver(_response);
        });
    }

    protected processUpdateDriver(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDriver(id: number, body: DriverDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Driver/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDriver(_response);
        });
    }

    protected processDeleteDriver(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getDriverByName(name: string | undefined): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver/byName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverByName(_response);
        });
    }

    protected processGetDriverByName(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverDto>(null as any);
    }

    /**
     * @param azObjId (optional) 
     * @return Success
     */
    getDriverByAzObjId(azObjId: string | undefined): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver/byAzObjId?";
        if (azObjId === null)
            throw new Error("The parameter 'azObjId' cannot be null.");
        else if (azObjId !== undefined)
            url_ += "azObjId=" + encodeURIComponent("" + azObjId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverByAzObjId(_response);
        });
    }

    protected processGetDriverByAzObjId(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverDto>(null as any);
    }

    /**
     * @return Success
     */
    getDriverByJobPositionId(id: number): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver/JobPosition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverByJobPositionId(_response);
        });
    }

    protected processGetDriverByJobPositionId(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewDriver(body: DriverDto | undefined): Promise<DriverDto> {
        let url_ = this.baseUrl + "/api/Driver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewDriver(_response);
        });
    }

    protected processAddNewDriver(response: Response): Promise<DriverDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getDriverDocuments(id: number, category: string): Promise<EmployeeDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Driver/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverDocuments(_response);
        });
    }

    protected processGetDriverDocuments(response: Response): Promise<EmployeeDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveDriverDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Driver/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDriverDocument(_response);
        });
    }

    protected processSaveDriverDocument(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteDriverDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Driver/{id}/document/{documentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDriverDocument(_response);
        });
    }

    protected processDeleteDriverDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param onlyFinished (optional) 
     * @param clientId (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getDriverTransportWarrants(id: number, onlyFinished: boolean | undefined, clientId: number | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<TransportWarrantDto[]> {
        let url_ = this.baseUrl + "/api/Driver/{id}/transportWarrants?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (onlyFinished === null)
            throw new Error("The parameter 'onlyFinished' cannot be null.");
        else if (onlyFinished !== undefined)
            url_ += "onlyFinished=" + encodeURIComponent("" + onlyFinished) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverTransportWarrants(_response);
        });
    }

    protected processGetDriverTransportWarrants(response: Response): Promise<TransportWarrantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportWarrantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportWarrantDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDriverAlarms(id: number): Promise<AlarmDto[]> {
        let url_ = this.baseUrl + "/api/Driver/{id}/alarms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDriverAlarms(_response);
        });
    }

    protected processGetDriverAlarms(response: Response): Promise<AlarmDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: EmployeeAccountDto | undefined): Promise<AuthenticatedDto> {
        let url_ = this.baseUrl + "/api/Employee/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthenticatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/Employee/all?";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteEmployee(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmployee(_response);
        });
    }

    protected processDeleteEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getEmployees(type: JobPositionType | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/Employee?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployee(_response);
        });
    }

    protected processAddNewEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto> {
        let url_ = this.baseUrl + "/api/Employee/myInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: Response): Promise<EmployeeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getEmployeeDocuments(id: number, category: string): Promise<EmployeeDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeDocuments(_response);
        });
    }

    protected processGetEmployeeDocuments(response: Response): Promise<EmployeeDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveEmployeeDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Employee/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveEmployeeDocument(_response);
        });
    }

    protected processSaveEmployeeDocument(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteEmployeeDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{id}/document/{documentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmployeeDocument(_response);
        });
    }

    protected processDeleteEmployeeDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeAccount(employeeId: number): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/EmployeeAccount";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeAccount(_response);
        });
    }

    protected processGetEmployeeAccount(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/EmployeeAccount";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeAccount(_response);
        });
    }

    protected processAddNewEmployeeAccount(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployeeAccountPassword(accId: number, body: ChangePasswordDto | undefined): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/EmployeeAccount/{accId}/Password";
        if (accId === undefined || accId === null)
            throw new Error("The parameter 'accId' must be defined.");
        url_ = url_.replace("{accId}", encodeURIComponent("" + accId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployeeAccountPassword(_response);
        });
    }

    protected processUpdateEmployeeAccountPassword(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedRequestResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeContactInfo(employeeId: number, body: EmployeeContactInfoDto | undefined): Promise<EmployeeContactInfoDto> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/ContactInfo";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeContactInfo(_response);
        });
    }

    protected processAddNewEmployeeContactInfo(response: Response): Promise<EmployeeContactInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeContactInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeAccount(body: EmployeeAccountDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/EmployeeAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmployeeAccount(_response);
        });
    }

    protected processDeleteEmployeeAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserName(body: EmployeeAccountDto | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Employee/CheckUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUserName(_response);
        });
    }

    protected processCheckUserName(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getEmployeeJobPositions(employeeId: number): Promise<JobPositionDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/JobPositions";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeJobPositions(_response);
        });
    }

    protected processGetEmployeeJobPositions(response: Response): Promise<JobPositionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobPositionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobPositionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/JobPosition";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewJobPosition(_response);
        });
    }

    protected processAddNewJobPosition(response: Response): Promise<JobPositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedRequestResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getSingleEmployeeUserGroup(id: number): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/Employee/{id}/userGroup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleEmployeeUserGroup(_response);
        });
    }

    protected processGetSingleEmployeeUserGroup(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllEmployeeUserGroups(id: number): Promise<UserGroupDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/userGroups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployeeUserGroups(_response);
        });
    }

    protected processGetAllEmployeeUserGroups(response: Response): Promise<UserGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param notificationMedia (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllEmployeeNotifications(id: number, notificationMedia: NotificationMedia | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/notifications?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (notificationMedia === null)
            throw new Error("The parameter 'notificationMedia' cannot be null.");
        else if (notificationMedia !== undefined)
            url_ += "notificationMedia=" + encodeURIComponent("" + notificationMedia) + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployeeNotifications(_response);
        });
    }

    protected processGetAllEmployeeNotifications(response: Response): Promise<NotificationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param notificationMedia (optional) 
     * @return Success
     */
    getAllEmployeeTimeEvents(id: number, notificationMedia: NotificationMedia | undefined): Promise<TimeEventDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/timeEvents?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (notificationMedia === null)
            throw new Error("The parameter 'notificationMedia' cannot be null.");
        else if (notificationMedia !== undefined)
            url_ += "notificationMedia=" + encodeURIComponent("" + notificationMedia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployeeTimeEvents(_response);
        });
    }

    protected processGetAllEmployeeTimeEvents(response: Response): Promise<TimeEventDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param notificationMedia (optional) 
     * @return Success
     */
    getAllEmployeeKmEvents(id: number, notificationMedia: NotificationMedia | undefined): Promise<KmEventDto[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/kmEvents?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (notificationMedia === null)
            throw new Error("The parameter 'notificationMedia' cannot be null.");
        else if (notificationMedia !== undefined)
            url_ += "notificationMedia=" + encodeURIComponent("" + notificationMedia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployeeKmEvents(_response);
        });
    }

    protected processGetAllEmployeeKmEvents(response: Response): Promise<KmEventDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KmEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTimeEvent(body: TimeEventDto | undefined): Promise<TimeEventDto> {
        let url_ = this.baseUrl + "/api/Event/time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTimeEvent(_response);
        });
    }

    protected processAddTimeEvent(response: Response): Promise<TimeEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addKmEvent(body: KmEventDto | undefined): Promise<KmEventDto> {
        let url_ = this.baseUrl + "/api/Event/km";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKmEvent(_response);
        });
    }

    protected processAddKmEvent(response: Response): Promise<KmEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimeEvent(id: number, body: TimeEventDto | undefined): Promise<TimeEventDto> {
        let url_ = this.baseUrl + "/api/Event/time/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTimeEvent(_response);
        });
    }

    protected processUpdateTimeEvent(response: Response): Promise<TimeEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKmEvent(id: number, body: KmEventDto | undefined): Promise<KmEventDto> {
        let url_ = this.baseUrl + "/api/Event/km/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateKmEvent(_response);
        });
    }

    protected processUpdateKmEvent(response: Response): Promise<KmEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    checkForValidEvents(): Promise<void> {
        let url_ = this.baseUrl + "/api/Event/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckForValidEvents(_response);
        });
    }

    protected processCheckForValidEvents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteEvent(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEvent(_response);
        });
    }

    protected processDeleteEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getInvoice(id: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: Response): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvoice(id: number, body: InvoiceDto | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInvoice(_response);
        });
    }

    protected processUpdateInvoice(response: Response): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteInvoice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInvoice(_response);
        });
    }

    protected processDeleteInvoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getInvoiceByCode(code: string): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoice/byCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoiceByCode(_response);
        });
    }

    protected processGetInvoiceByCode(response: Response): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
    
    /**
     * @param body (optional) 
     * @return Success
     */
    updateJobPosition(id: number, body: JobPositionDto | undefined): Promise<JobPositionDto> {
        let url_ = this.baseUrl + "/api/JobPosition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateJobPosition(_response);
        });
    }

    protected processUpdateJobPosition(response: Response): Promise<JobPositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JobPosition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobPosition(_response);
        });
    }

    protected processDeleteJobPosition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNotification(body: NotificationDto | undefined): Promise<NotificationDto> {
        let url_ = this.baseUrl + "/api/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNotification(_response);
        });
    }

    protected processAddNotification(response: Response): Promise<NotificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotification(id: number, body: NotificationDto | undefined): Promise<NotificationDto> {
        let url_ = this.baseUrl + "/api/Notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNotification(_response);
        });
    }

    protected processUpdateNotification(response: Response): Promise<NotificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeConstructionSites (optional) 
     * @return Success
     */
    getProject(id: number, includeConstructionSites: boolean | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/Project/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeConstructionSites === null)
            throw new Error("The parameter 'includeConstructionSites' cannot be null.");
        else if (includeConstructionSites !== undefined)
            url_ += "includeConstructionSites=" + encodeURIComponent("" + includeConstructionSites) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProject(id: number, body: ProjectDto | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteProject(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewProject(body: ProjectDto | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewProject(_response);
        });
    }

    protected processAddNewProject(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeProject (optional) 
     * @return Success
     */
    getConstructionSite(id: number, includeProject: boolean | undefined): Promise<ConstructionSiteDto> {
        let url_ = this.baseUrl + "/api/Project/constructionSites/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeProject === null)
            throw new Error("The parameter 'includeProject' cannot be null.");
        else if (includeProject !== undefined)
            url_ += "includeProject=" + encodeURIComponent("" + includeProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConstructionSite(_response);
        });
    }

    protected processGetConstructionSite(response: Response): Promise<ConstructionSiteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstructionSiteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConstructionSiteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConstructionSite(id: number, body: ConstructionSiteDto | undefined): Promise<ConstructionSiteDto> {
        let url_ = this.baseUrl + "/api/Project/constructionSites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConstructionSite(_response);
        });
    }

    protected processUpdateConstructionSite(response: Response): Promise<ConstructionSiteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstructionSiteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteConstructionSite(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/constructionSites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConstructionSite(_response);
        });
    }

    protected processDeleteConstructionSite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewConstructionSite(body: ConstructionSiteDto | undefined): Promise<ConstructionSiteDto> {
        let url_ = this.baseUrl + "/api/Project/constructionSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewConstructionSite(_response);
        });
    }

    protected processAddNewConstructionSite(response: Response): Promise<ConstructionSiteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstructionSiteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllConstructionSitesForProject(projectId: number): Promise<ConstructionSiteDto[]> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/constructionSites";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllConstructionSitesForProject(_response);
        });
    }

    protected processGetAllConstructionSitesForProject(response: Response): Promise<ConstructionSiteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConstructionSiteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConstructionSiteDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRecordDocuments(recordId: number, category: string): Promise<RecordDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/docs/{category}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecordDocuments(_response);
        });
    }

    protected processGetRecordDocuments(response: Response): Promise<RecordDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveRecordDocument(recordId: number, category: string, files: File[] | undefined, data: string | undefined): Promise<RecordDocumentDto> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/docs/{category}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRecordDocument(_response);
        });
    }

    protected processSaveRecordDocument(response: Response): Promise<RecordDocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    sendUploadMediaRequest(recordId: number, category: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/docs/{category}/mediaUploadRequest";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendUploadMediaRequest(_response);
        });
    }

    protected processSendUploadMediaRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteRecordDocument(recordId: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/document/{documentId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRecordDocument(_response);
        });
    }

    protected processDeleteRecordDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeRecord(id: number, body: EmployeeRecordDto | undefined): Promise<EmployeeRecordDto> {
        let url_ = this.baseUrl + "/api/Records/employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeRecord(_response);
        });
    }

    protected processAddNewEmployeeRecord(response: Response): Promise<EmployeeRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllEmployeeRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<EmployeeRecordDto[]> {
        let url_ = this.baseUrl + "/api/Records/employee/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (recordCategory === null)
            throw new Error("The parameter 'recordCategory' cannot be null.");
        else if (recordCategory !== undefined)
            url_ += "RecordCategory=" + encodeURIComponent("" + recordCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployeeRecords(_response);
        });
    }

    protected processGetAllEmployeeRecords(response: Response): Promise<EmployeeRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRecordDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployeeRecord(id: number, body: EmployeeRecordDto | undefined): Promise<EmployeeRecordDto> {
        let url_ = this.baseUrl + "/api/Records/{id}/employee";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployeeRecord(_response);
        });
    }

    protected processUpdateEmployeeRecord(response: Response): Promise<EmployeeRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewVehicleRecord(vehicleId: number, body: VehicleRecordDto | undefined): Promise<VehicleRecordDto> {
        let url_ = this.baseUrl + "/api/Records/vehicles/{vehicleId}";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewVehicleRecord(_response);
        });
    }

    protected processAddNewVehicleRecord(response: Response): Promise<VehicleRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllVehicleRecords(vehicleId: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<VehicleRecordDto[]> {
        let url_ = this.baseUrl + "/api/Records/vehicles/{vehicleId}?";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        if (recordCategory === null)
            throw new Error("The parameter 'recordCategory' cannot be null.");
        else if (recordCategory !== undefined)
            url_ += "RecordCategory=" + encodeURIComponent("" + recordCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllVehicleRecords(_response);
        });
    }

    protected processGetAllVehicleRecords(response: Response): Promise<VehicleRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleRecordDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVehicleRecord(recordId: number, body: VehicleRecordDto | undefined): Promise<VehicleRecordDto> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/vehicles";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVehicleRecord(_response);
        });
    }

    protected processUpdateVehicleRecord(response: Response): Promise<VehicleRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteVehicleRecord(recordId: number, body: VehicleRecordDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/vehicles";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicleRecord(_response);
        });
    }

    protected processDeleteVehicleRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteVehicleExpense(expenseId: number, body: VehicleExpenseDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/expenses/{expenseId}/vehicles";
        if (expenseId === undefined || expenseId === null)
            throw new Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicleExpense(_response);
        });
    }

    protected processDeleteVehicleExpense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewVehicleExpense(id: number, body: VehicleExpenseDto | undefined): Promise<VehicleExpenseDto> {
        let url_ = this.baseUrl + "/api/Records/expenses/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewVehicleExpense(_response);
        });
    }

    protected processAddNewVehicleExpense(response: Response): Promise<VehicleExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param expenseCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllVehicleExpenses(id: number, expenseCategory: ExpenseCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<VehicleExpenseDto[]> {
        let url_ = this.baseUrl + "/api/Records/expenses/vehicles/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "ExpenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllVehicleExpenses(_response);
        });
    }

    protected processGetAllVehicleExpenses(response: Response): Promise<VehicleExpenseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleExpenseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleExpenseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVehicleExpense(id: number, body: VehicleExpenseDto | undefined): Promise<VehicleExpenseDto> {
        let url_ = this.baseUrl + "/api/Records/expenses/{id}/vehicles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVehicleExpense(_response);
        });
    }

    protected processUpdateVehicleExpense(response: Response): Promise<VehicleExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param middleDate (optional) 
     * @param sumType (optional) 
     * @param expenseCategory (optional) 
     * @param id (optional) 
     * @param isKmExpense (optional) 
     * @return Success
     */
    getAllVehicleExpensesSums(middleDate: Date | undefined, sumType: SumType | undefined, expenseCategory: ExpenseCategory | undefined, id: number | undefined, isKmExpense: boolean | undefined): Promise<SumsDto[]> {
        let url_ = this.baseUrl + "/api/Records/expensesSum/vehicles?";
        if (middleDate === null)
            throw new Error("The parameter 'middleDate' cannot be null.");
        else if (middleDate !== undefined)
            url_ += "middleDate=" + encodeURIComponent(middleDate ? "" + middleDate.toJSON() : "") + "&";
        if (sumType === null)
            throw new Error("The parameter 'sumType' cannot be null.");
        else if (sumType !== undefined)
            url_ += "sumType=" + encodeURIComponent("" + sumType) + "&";
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "expenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isKmExpense === null)
            throw new Error("The parameter 'isKmExpense' cannot be null.");
        else if (isKmExpense !== undefined)
            url_ += "isKmExpense=" + encodeURIComponent("" + isKmExpense) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllVehicleExpensesSums(_response);
        });
    }

    protected processGetAllVehicleExpensesSums(response: Response): Promise<SumsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SumsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SumsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingToolRecord(id: number, body: WorkingToolRecordDto | undefined): Promise<WorkingToolRecordDto> {
        let url_ = this.baseUrl + "/api/Records/workingTool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewWorkingToolRecord(_response);
        });
    }

    protected processAddNewWorkingToolRecord(response: Response): Promise<WorkingToolRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllWorkingToolRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<WorkingToolRecordDto[]> {
        let url_ = this.baseUrl + "/api/Records/workingTool/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (recordCategory === null)
            throw new Error("The parameter 'recordCategory' cannot be null.");
        else if (recordCategory !== undefined)
            url_ += "RecordCategory=" + encodeURIComponent("" + recordCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkingToolRecords(_response);
        });
    }

    protected processGetAllWorkingToolRecords(response: Response): Promise<WorkingToolRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingToolRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingToolRecordDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingToolRecord(id: number, body: WorkingToolRecordDto | undefined): Promise<WorkingToolRecordDto> {
        let url_ = this.baseUrl + "/api/Records/{id}/workingTool";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkingToolRecord(_response);
        });
    }

    protected processUpdateWorkingToolRecord(response: Response): Promise<WorkingToolRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingToolExpense(id: number, body: WorkingToolExpenseDto | undefined): Promise<WorkingToolExpenseDto> {
        let url_ = this.baseUrl + "/api/Records/expenses/workingTool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewWorkingToolExpense(_response);
        });
    }

    protected processAddNewWorkingToolExpense(response: Response): Promise<WorkingToolExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param expenseCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllWorkingToolExpenses(id: number, expenseCategory: ExpenseCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<WorkingToolExpenseDto[]> {
        let url_ = this.baseUrl + "/api/Records/expenses/workingTool/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "ExpenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkingToolExpenses(_response);
        });
    }

    protected processGetAllWorkingToolExpenses(response: Response): Promise<WorkingToolExpenseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingToolExpenseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingToolExpenseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingToolExpense(id: number, body: WorkingToolExpenseDto | undefined): Promise<WorkingToolExpenseDto> {
        let url_ = this.baseUrl + "/api/Records/expenses/{id}/workingTool";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkingToolExpense(_response);
        });
    }

    protected processUpdateWorkingToolExpense(response: Response): Promise<WorkingToolExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWorkingToolRecord(recordId: number, body: WorkingToolRecordDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/{recordId}/workingTools";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkingToolRecord(_response);
        });
    }

    protected processDeleteWorkingToolRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWorkingToolExpense(expenseId: number, body: WorkingToolExpenseDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Records/expenses/{expenseId}/workingTools";
        if (expenseId === undefined || expenseId === null)
            throw new Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkingToolExpense(_response);
        });
    }

    protected processDeleteWorkingToolExpense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param middleDate (optional) 
     * @param sumType (optional) 
     * @param expenseCategory (optional) 
     * @param id (optional) 
     * @param isKmExpense (optional) 
     * @return Success
     */
    getAllWorkingToolExpensesSums(middleDate: Date | undefined, sumType: SumType | undefined, expenseCategory: ExpenseCategory | undefined, id: number | undefined, isKmExpense: boolean | undefined): Promise<SumsDto[]> {
        let url_ = this.baseUrl + "/api/Records/expensesSum/workingTool?";
        if (middleDate === null)
            throw new Error("The parameter 'middleDate' cannot be null.");
        else if (middleDate !== undefined)
            url_ += "middleDate=" + encodeURIComponent(middleDate ? "" + middleDate.toJSON() : "") + "&";
        if (sumType === null)
            throw new Error("The parameter 'sumType' cannot be null.");
        else if (sumType !== undefined)
            url_ += "sumType=" + encodeURIComponent("" + sumType) + "&";
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "expenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isKmExpense === null)
            throw new Error("The parameter 'isKmExpense' cannot be null.");
        else if (isKmExpense !== undefined)
            url_ += "isKmExpense=" + encodeURIComponent("" + isKmExpense) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkingToolExpensesSums(_response);
        });
    }

    protected processGetAllWorkingToolExpensesSums(response: Response): Promise<SumsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SumsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SumsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewClientRecord(id: number, body: ClientRecordDto | undefined): Promise<ClientRecordDto> {
        let url_ = this.baseUrl + "/api/Records/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewClientRecord(_response);
        });
    }

    protected processAddNewClientRecord(response: Response): Promise<ClientRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param recordCategory (optional) 
     * @param searchText (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getAllClientRecords(id: number, recordCategory: RecordCategory | undefined, searchText: string | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<ClientRecordDto[]> {
        let url_ = this.baseUrl + "/api/Records/client/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (recordCategory === null)
            throw new Error("The parameter 'recordCategory' cannot be null.");
        else if (recordCategory !== undefined)
            url_ += "RecordCategory=" + encodeURIComponent("" + recordCategory) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllClientRecords(_response);
        });
    }

    protected processGetAllClientRecords(response: Response): Promise<ClientRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientRecordDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientRecord(id: number, body: ClientRecordDto | undefined): Promise<ClientRecordDto> {
        let url_ = this.baseUrl + "/api/Records/{id}/client";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateClientRecord(_response);
        });
    }

    protected processUpdateClientRecord(response: Response): Promise<ClientRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param sumType (optional) 
     * @param endDate (optional) 
     * @param expenseCategory (optional) 
     * @return Success
     */
    getTruckPricePerKm(id: number, sumType: SumType | undefined, endDate: Date | undefined, expenseCategory: ExpenseCategory | undefined): Promise<SumsDto[]> {
        let url_ = this.baseUrl + "/api/Records/pricePerKm/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sumType === null)
            throw new Error("The parameter 'sumType' cannot be null.");
        else if (sumType !== undefined)
            url_ += "sumType=" + encodeURIComponent("" + sumType) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "expenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTruckPricePerKm(_response);
        });
    }

    protected processGetTruckPricePerKm(response: Response): Promise<SumsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SumsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTruckFuelPricePerKm(id: number, startDate: Date | undefined, endDate: Date | undefined): Promise<FuelSumsDto[]> {
        let url_ = this.baseUrl + "/api/Records/fuelPricePerKm/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTruckFuelPricePerKm(_response);
        });
    }

    protected processGetTruckFuelPricePerKm(response: Response): Promise<FuelSumsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelSumsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param expenseCategory (optional) 
     * @return Success
     */
    getExpenseTypes(expenseCategory: ExpenseCategory | undefined): Promise<ExpenseTypeDto[]> {
        let url_ = this.baseUrl + "/api/Records/expenseTypes?";
        if (expenseCategory === null)
            throw new Error("The parameter 'expenseCategory' cannot be null.");
        else if (expenseCategory !== undefined)
            url_ += "expenseCategory=" + encodeURIComponent("" + expenseCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpenseTypes(_response);
        });
    }

    protected processGetExpenseTypes(response: Response): Promise<ExpenseTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseTypeDto[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getExpenseTypeByName(name: string | undefined): Promise<ExpenseTypeDto> {
        let url_ = this.baseUrl + "/api/Records/expenseType/byName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpenseTypeByName(_response);
        });
    }

    protected processGetExpenseTypeByName(response: Response): Promise<ExpenseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addExpenseType(body: ExpenseTypeDto | undefined): Promise<ExpenseTypeDto> {
        let url_ = this.baseUrl + "/api/Records/expenseType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpenseType(_response);
        });
    }

    protected processAddExpenseType(response: Response): Promise<ExpenseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExpenseType(id: number, body: ExpenseTypeDto | undefined): Promise<ExpenseTypeDto> {
        let url_ = this.baseUrl + "/api/Records/expenseType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpenseType(_response);
        });
    }

    protected processUpdateExpenseType(response: Response): Promise<ExpenseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getRecordAlarms(id: number): Promise<AlarmDto[]> {
        let url_ = this.baseUrl + "/api/Records/{id}/alarms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecordAlarms(_response);
        });
    }

    protected processGetRecordAlarms(response: Response): Promise<AlarmDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmDto[]>(null as any);
    }

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getActiveShipments(includeStops: boolean | undefined): Promise<ShipmentDto[]> {
        let url_ = this.baseUrl + "/api/Shipment/active?";
        if (includeStops === null)
            throw new Error("The parameter 'includeStops' cannot be null.");
        else if (includeStops !== undefined)
            url_ += "includeStops=" + encodeURIComponent("" + includeStops) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveShipments(_response);
        });
    }

    protected processGetActiveShipments(response: Response): Promise<ShipmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentDto[]>(null as any);
    }

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getAllShipments(includeStops: boolean | undefined): Promise<ShipmentDto[]> {
        let url_ = this.baseUrl + "/api/Shipment?";
        if (includeStops === null)
            throw new Error("The parameter 'includeStops' cannot be null.");
        else if (includeStops !== undefined)
            url_ += "includeStops=" + encodeURIComponent("" + includeStops) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllShipments(_response);
        });
    }

    protected processGetAllShipments(response: Response): Promise<ShipmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewShipment(body: ShipmentDto | undefined): Promise<ShipmentDto> {
        let url_ = this.baseUrl + "/api/Shipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewShipment(_response);
        });
    }

    protected processAddNewShipment(response: Response): Promise<ShipmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getShipment(id: number, includeStops: boolean | undefined): Promise<ShipmentDto> {
        let url_ = this.baseUrl + "/api/Shipment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeStops === null)
            throw new Error("The parameter 'includeStops' cannot be null.");
        else if (includeStops !== undefined)
            url_ += "includeStops=" + encodeURIComponent("" + includeStops) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShipment(_response);
        });
    }

    protected processGetShipment(response: Response): Promise<ShipmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShipment(id: number, body: ShipmentDto | undefined): Promise<ShipmentDto> {
        let url_ = this.baseUrl + "/api/Shipment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateShipment(_response);
        });
    }

    protected processUpdateShipment(response: Response): Promise<ShipmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteShipment(id: number, body: ShipmentDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Shipment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteShipment(_response);
        });
    }

    protected processDeleteShipment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeStops (optional) 
     * @return Success
     */
    getShipmentByName(title: string, includeStops: boolean | undefined): Promise<ShipmentDto> {
        let url_ = this.baseUrl + "/api/Shipment/byTitle/{title}?";
        if (title === undefined || title === null)
            throw new Error("The parameter 'title' must be defined.");
        url_ = url_.replace("{title}", encodeURIComponent("" + title));
        if (includeStops === null)
            throw new Error("The parameter 'includeStops' cannot be null.");
        else if (includeStops !== undefined)
            url_ += "includeStops=" + encodeURIComponent("" + includeStops) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShipmentByName(_response);
        });
    }

    protected processGetShipmentByName(response: Response): Promise<ShipmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllShipmentCustomers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Shipment/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllShipmentCustomers(_response);
        });
    }

    protected processGetAllShipmentCustomers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getStop(id: number): Promise<StopDto> {
        let url_ = this.baseUrl + "/api/Stop/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStop(_response);
        });
    }

    protected processGetStop(response: Response): Promise<StopDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StopDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StopDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStop(id: number, body: StopDto | undefined): Promise<StopDto> {
        let url_ = this.baseUrl + "/api/Stop/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStop(_response);
        });
    }

    protected processUpdateStop(response: Response): Promise<StopDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StopDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteStop(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Stop/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStop(_response);
        });
    }

    protected processDeleteStop(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllStops(): Promise<StopDto[]> {
        let url_ = this.baseUrl + "/api/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllStops(_response);
        });
    }

    protected processGetAllStops(response: Response): Promise<StopDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StopDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StopDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewStop(body: StopDto | undefined): Promise<StopDto> {
        let url_ = this.baseUrl + "/api/Stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewStop(_response);
        });
    }

    protected processAddNewStop(response: Response): Promise<StopDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StopDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getStopByName(name: string): Promise<StopDto> {
        let url_ = this.baseUrl + "/api/Stop/byName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStopByName(_response);
        });
    }

    protected processGetStopByName(response: Response): Promise<StopDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StopDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getUserGroupByName(name: string | undefined): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/UserGroup/byName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupByName(_response);
        });
    }

    protected processGetUserGroupByName(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserGroupById(id: number): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/UserGroup/time/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupById(_response);
        });
    }

    protected processGetUserGroupById(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserGroup(body: UserGroupDto | undefined): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/UserGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserGroup(_response);
        });
    }

    protected processAddUserGroup(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGroup(id: number, body: UserGroupDto | undefined): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/UserGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserGroup(_response);
        });
    }

    protected processUpdateUserGroup(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserGroup(id: number, body: UserGroupDto | undefined): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/UserGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserGroup(_response);
        });
    }

    protected processDeleteUserGroup(response: Response): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllCars(): Promise<CarDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/cars";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCars(_response);
        });
    }

    protected processGetAllCars(response: Response): Promise<CarDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewCar(body: CarDto | undefined): Promise<CarDto> {
        let url_ = this.baseUrl + "/api/Vehicle/cars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewCar(_response);
        });
    }

    protected processAddNewCar(response: Response): Promise<CarDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllTrucks(): Promise<TruckDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/trucks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTrucks(_response);
        });
    }

    protected processGetAllTrucks(response: Response): Promise<TruckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TruckDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TruckDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTruck(body: TruckDto | undefined): Promise<TruckDto> {
        let url_ = this.baseUrl + "/api/Vehicle/trucks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewTruck(_response);
        });
    }

    protected processAddNewTruck(response: Response): Promise<TruckDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllTrailers(): Promise<TrailerDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/trailers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTrailers(_response);
        });
    }

    protected processGetAllTrailers(response: Response): Promise<TrailerDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrailerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrailerDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTrailer(body: TrailerDto | undefined): Promise<TrailerDto> {
        let url_ = this.baseUrl + "/api/Vehicle/trailers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewTrailer(_response);
        });
    }

    protected processAddNewTrailer(response: Response): Promise<TrailerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrailerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrailer(id: number, body: TrailerDto | undefined): Promise<TrailerDto> {
        let url_ = this.baseUrl + "/api/Vehicle/trailers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTrailer(_response);
        });
    }

    protected processUpdateTrailer(response: Response): Promise<TrailerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrailerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCar(id: number, body: CarDto | undefined): Promise<CarDto> {
        let url_ = this.baseUrl + "/api/Vehicle/cars/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCar(_response);
        });
    }

    protected processUpdateCar(response: Response): Promise<CarDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTruck(id: number, body: TruckDto | undefined): Promise<TruckDto> {
        let url_ = this.baseUrl + "/api/Vehicle/trucks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTruck(_response);
        });
    }

    protected processUpdateTruck(response: Response): Promise<TruckDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param manufacturer (optional) 
     * @return Success
     */
    getModels(manufacturer: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Vehicle/models?";
        if (manufacturer === null)
            throw new Error("The parameter 'manufacturer' cannot be null.");
        else if (manufacturer !== undefined)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetModels(_response);
        });
    }

    protected processGetModels(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getManufacturers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Vehicle/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetManufacturers(_response);
        });
    }

    protected processGetManufacturers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    deleteVehicle(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehicle(_response);
        });
    }

    protected processDeleteVehicle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getVehicle(id: number): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicle(_response);
        });
    }

    protected processGetVehicle(response: Response): Promise<VehicleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    /**
     * @return Success
     */
    getVehicleDocuments(id: number, category: string): Promise<VehicleDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleDocuments(_response);
        });
    }

    protected processGetVehicleDocuments(response: Response): Promise<VehicleDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveVehicleDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveVehicleDocument(_response);
        });
    }

    protected processSaveVehicleDocument(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteVehiclesDocument(vehicleId: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Vehicle/{vehicleId}/document/{documentId}";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteVehiclesDocument(_response);
        });
    }

    protected processDeleteVehiclesDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param onlyFinished (optional) 
     * @param clientId (optional) 
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param lastEntityId (optional) 
     * @param numberOfEntitiesToReturn (optional) 
     * @return Success
     */
    getVehicleTransportWarrants(id: number, onlyFinished: boolean | undefined, clientId: number | undefined, startingDate: Date | undefined, endingDate: Date | undefined, lastEntityId: number | undefined, numberOfEntitiesToReturn: number | undefined): Promise<TransportWarrantDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/transportWarrants?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (onlyFinished === null)
            throw new Error("The parameter 'onlyFinished' cannot be null.");
        else if (onlyFinished !== undefined)
            url_ += "onlyFinished=" + encodeURIComponent("" + onlyFinished) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "StartingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "EndingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (lastEntityId === null)
            throw new Error("The parameter 'lastEntityId' cannot be null.");
        else if (lastEntityId !== undefined)
            url_ += "lastEntityId=" + encodeURIComponent("" + lastEntityId) + "&";
        if (numberOfEntitiesToReturn === null)
            throw new Error("The parameter 'numberOfEntitiesToReturn' cannot be null.");
        else if (numberOfEntitiesToReturn !== undefined)
            url_ += "numberOfEntitiesToReturn=" + encodeURIComponent("" + numberOfEntitiesToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleTransportWarrants(_response);
        });
    }

    protected processGetVehicleTransportWarrants(response: Response): Promise<TransportWarrantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportWarrantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportWarrantDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCarTravelWarrants(id: number): Promise<TravelWarrantDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/travelWarrants";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarTravelWarrants(_response);
        });
    }

    protected processGetCarTravelWarrants(response: Response): Promise<TravelWarrantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TravelWarrantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelWarrantDto[]>(null as any);
    }

    /**
     * @param lpNum (optional) 
     * @return Success
     */
    getVehicleByLicensePlateNum(lpNum: string | undefined): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/api/Vehicle/byLicensePlateNum?";
        if (lpNum === null)
            throw new Error("The parameter 'lpNum' cannot be null.");
        else if (lpNum !== undefined)
            url_ += "lpNum=" + encodeURIComponent("" + lpNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleByLicensePlateNum(_response);
        });
    }

    protected processGetVehicleByLicensePlateNum(response: Response): Promise<VehicleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    /**
     * @return Success
     */
    getVehicleAlarms(id: number): Promise<AlarmDto[]> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/alarms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleAlarms(_response);
        });
    }

    protected processGetVehicleAlarms(response: Response): Promise<AlarmDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLastKmForDate(id: number, currentDate: Date | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/lastKmForDate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (currentDate === null)
            throw new Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastKmForDate(_response);
        });
    }

    protected processGetLastKmForDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @return Success
     */
    getKmDifferenceForDates(id: number, startingDate: Date | undefined, endingDate: Date | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Vehicle/{id}/kmDifferenceForDates?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "startingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "endingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKmDifferenceForDates(_response);
        });
    }

    protected processGetKmDifferenceForDates(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getVehicleExpenseByExpId(id: number): Promise<VehicleExpenseDto> {
        let url_ = this.baseUrl + "/api/Vehicle/expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleExpenseByExpId(_response);
        });
    }

    protected processGetVehicleExpenseByExpId(response: Response): Promise<VehicleExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleExpenseDto>(null as any);
    }

    /**
     * @return Success
     */
    getVehicleRecordByRecId(id: number): Promise<VehicleRecordDto> {
        let url_ = this.baseUrl + "/api/Vehicle/record/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleRecordByRecId(_response);
        });
    }

    protected processGetVehicleRecordByRecId(response: Response): Promise<VehicleRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleRecordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleRecordDto>(null as any);
    }

    /**
     * @return Success
     */
    getNewSubscribedUsers(): Promise<EmployeeContactInfoDto[]> {
        let url_ = this.baseUrl + "/api/ViberBot/freshlySubscribedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewSubscribedUsers(_response);
        });
    }

    protected processGetNewSubscribedUsers(response: Response): Promise<EmployeeContactInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeContactInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeContactInfoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTravelWarrant(body: TravelWarrantDto | undefined): Promise<TravelWarrantDto> {
        let url_ = this.baseUrl + "/api/Warrant/travelWarrant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewTravelWarrant(_response);
        });
    }

    protected processAddNewTravelWarrant(response: Response): Promise<TravelWarrantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelWarrantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTravelWarrant(id: number, body: TravelWarrantDto | undefined): Promise<TravelWarrantDto> {
        let url_ = this.baseUrl + "/api/Warrant/travelWarrant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTravelWarrant(_response);
        });
    }

    protected processUpdateTravelWarrant(response: Response): Promise<TravelWarrantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelWarrantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteTravelWarrant(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Warrant/travelWarrant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTravelWarrant(_response);
        });
    }

    protected processDeleteTravelWarrant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @return Success
     */
    getTravelWarrantsForDateRange(startingDate: Date | undefined, endingDate: Date | undefined): Promise<TravelWarrantDto[]> {
        let url_ = this.baseUrl + "/api/Warrant/travelWarrant/dateRange?";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "startingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "endingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTravelWarrantsForDateRange(_response);
        });
    }

    protected processGetTravelWarrantsForDateRange(response: Response): Promise<TravelWarrantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TravelWarrantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTransportWarrant(body: TransportWarrantDto | undefined): Promise<TransportWarrantDto> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewTransportWarrant(_response);
        });
    }

    protected processAddNewTransportWarrant(response: Response): Promise<TransportWarrantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportWarrantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransportWarrant(id: number, body: TransportWarrantDto | undefined): Promise<TransportWarrantDto> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransportWarrant(_response);
        });
    }

    protected processUpdateTransportWarrant(response: Response): Promise<TransportWarrantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportWarrantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTransportWarrant(id: number, body: TransportWarrantDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTransportWarrant(_response);
        });
    }

    protected processDeleteTransportWarrant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param startingDate (optional) 
     * @param endingDate (optional) 
     * @param includeTwItems (optional) 
     * @return Success
     */
    getTransportWarrantsForDateRange(startingDate: Date | undefined, endingDate: Date | undefined, includeTwItems: boolean | undefined): Promise<TransportWarrantDto[]> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/dateRange?";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "startingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        if (endingDate === null)
            throw new Error("The parameter 'endingDate' cannot be null.");
        else if (endingDate !== undefined)
            url_ += "endingDate=" + encodeURIComponent(endingDate ? "" + endingDate.toJSON() : "") + "&";
        if (includeTwItems === null)
            throw new Error("The parameter 'includeTwItems' cannot be null.");
        else if (includeTwItems !== undefined)
            url_ += "includeTwItems=" + encodeURIComponent("" + includeTwItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransportWarrantsForDateRange(_response);
        });
    }

    protected processGetTransportWarrantsForDateRange(response: Response): Promise<TransportWarrantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportWarrantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeTwItems (optional) 
     * @return Success
     */
    getTransportWarrant(id: number, includeTwItems: boolean | undefined): Promise<TransportWarrantDto> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (includeTwItems === null)
            throw new Error("The parameter 'includeTwItems' cannot be null.");
        else if (includeTwItems !== undefined)
            url_ += "includeTwItems=" + encodeURIComponent("" + includeTwItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransportWarrant(_response);
        });
    }

    protected processGetTransportWarrant(response: Response): Promise<TransportWarrantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportWarrantDto.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewTransportWarrantItem(body: TransportWarrantItemDto | undefined): Promise<TransportWarrantItemDto> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/transportWarrantItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewTransportWarrantItem(_response);
        });
    }

    protected processAddNewTransportWarrantItem(response: Response): Promise<TransportWarrantItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportWarrantItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransportWarrantItem(twiId: number, body: TransportWarrantItemDto | undefined): Promise<TransportWarrantItemDto> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/transportWarrantItem/{twiId}";
        if (twiId === undefined || twiId === null)
            throw new Error("The parameter 'twiId' must be defined.");
        url_ = url_.replace("{twiId}", encodeURIComponent("" + twiId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransportWarrantItem(_response);
        });
    }

    protected processUpdateTransportWarrantItem(response: Response): Promise<TransportWarrantItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportWarrantItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTransportWarrantItem(twiId: number, body: TransportWarrantItemDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/transportWarrantItem/{twiId}";
        if (twiId === undefined || twiId === null)
            throw new Error("The parameter 'twiId' must be defined.");
        url_ = url_.replace("{twiId}", encodeURIComponent("" + twiId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTransportWarrantItem(_response);
        });
    }

    protected processDeleteTransportWarrantItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getTransportWarrantItems(twId: number): Promise<TransportWarrantItemDto[]> {
        let url_ = this.baseUrl + "/api/Warrant/transportWarrant/{twId}/transportWarrantItems";
        if (twId === undefined || twId === null)
            throw new Error("The parameter 'twId' must be defined.");
        url_ = url_.replace("{twId}", encodeURIComponent("" + twId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransportWarrantItems(_response);
        });
    }

    protected processGetTransportWarrantItems(response: Response): Promise<TransportWarrantItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportWarrantItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllWorkingTools(): Promise<WorkingToolDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkingTools(_response);
        });
    }

    protected processGetAllWorkingTools(response: Response): Promise<WorkingToolDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingToolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingToolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkingMachines(): Promise<WorkingMachineDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/workingMachines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkingMachines(_response);
        });
    }

    protected processGetAllWorkingMachines(response: Response): Promise<WorkingMachineDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingMachineDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingMachineDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllOfficeMachines(): Promise<WorkingMachineDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/officeMachines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllOfficeMachines(_response);
        });
    }

    protected processGetAllOfficeMachines(response: Response): Promise<WorkingMachineDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingMachineDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingMachineDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllHandMachines(): Promise<WorkingMachineDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/handMachines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllHandMachines(_response);
        });
    }

    protected processGetAllHandMachines(response: Response): Promise<WorkingMachineDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingMachineDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingMachineDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingMachine(id: number): Promise<WorkingMachineDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/workingMachine/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingMachine(_response);
        });
    }

    protected processGetWorkingMachine(response: Response): Promise<WorkingMachineDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingMachineDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingMachineDto>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingTool(id: number): Promise<WorkingToolDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingTool(_response);
        });
    }

    protected processGetWorkingTool(response: Response): Promise<WorkingToolDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingToolDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingMachine(id: number, body: WorkingMachineDto | undefined): Promise<WorkingMachineDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/workingMachine/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkingMachine(_response);
        });
    }

    protected processUpdateWorkingMachine(response: Response): Promise<WorkingMachineDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingMachineDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingTool(body: WorkingToolDto | undefined): Promise<WorkingToolDto> {
        let url_ = this.baseUrl + "/api/WorkingTool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewWorkingTool(_response);
        });
    }

    protected processAddNewWorkingTool(response: Response): Promise<WorkingToolDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewWorkingMachine(body: WorkingMachineDto | undefined): Promise<WorkingMachineDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/workingMachine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewWorkingMachine(_response);
        });
    }

    protected processAddNewWorkingMachine(response: Response): Promise<WorkingMachineDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingMachineDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkingTool(id: number, body: WorkingToolDto | undefined): Promise<WorkingToolDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkingTool(_response);
        });
    }

    protected processUpdateWorkingTool(response: Response): Promise<WorkingToolDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingToolDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteWorkingTool(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkingTool(_response);
        });
    }

    protected processDeleteWorkingTool(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param manufacturer (optional) 
     * @return Success
     */
    getWorkingToolModels(manufacturer: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/models?";
        if (manufacturer === null)
            throw new Error("The parameter 'manufacturer' cannot be null.");
        else if (manufacturer !== undefined)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingToolModels(_response);
        });
    }

    protected processGetWorkingToolModels(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingToolManufacturers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingToolManufacturers(_response);
        });
    }

    protected processGetWorkingToolManufacturers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingToolDocuments(id: number, category: string): Promise<WorkingToolDocumentDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingToolDocuments(_response);
        });
    }

    protected processGetWorkingToolDocuments(response: Response): Promise<WorkingToolDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingToolDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkingToolDocumentDto[]>(null as any);
    }

    /**
     * @param files (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveWorkingToolDocument(id: number, category: string, files: File[] | undefined, data: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}/docs/{category}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_, item_.name? item_.name: "Files") );
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveWorkingToolDocument(_response);
        });
    }

    protected processSaveWorkingToolDocument(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteWorkingToolsDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}/document/{documentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkingToolsDocument(_response);
        });
    }

    protected processDeleteWorkingToolsDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingMachineAlarms(id: number): Promise<AlarmDto[]> {
        let url_ = this.baseUrl + "/api/WorkingTool/{id}/alarms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkingMachineAlarms(_response);
        });
    }

    protected processGetWorkingMachineAlarms(response: Response): Promise<AlarmDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmDto[]>(null as any);
    }
}

export interface IVNextClient {

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto>;

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]>;

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto>;

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void>;
}

export class VNextClient implements IVNextClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    oldAuthenticate(): Promise<AuthenticatedDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/OldAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOldAuthenticate(_response);
        });
    }

    protected processOldAuthenticate(response: Response): Promise<AuthenticatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param includeJobPositions (optional) 
     * @return Success
     */
    getAllEmployees(includeJobPositions: boolean | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/Employee/VNext/all?";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployee(id: number, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(id: number, body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param azureObjId (optional) 
     * @param includeAccount (optional) 
     * @param includeJobPositions (optional) 
     * @param includeContactInfo (optional) 
     * @return Success
     */
    getEmployeeByAzureObjId(azureObjId: string | undefined, includeAccount: boolean | undefined, includeJobPositions: boolean | undefined, includeContactInfo: boolean | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/byAzureObjId?";
        if (azureObjId === null)
            throw new Error("The parameter 'azureObjId' cannot be null.");
        else if (azureObjId !== undefined)
            url_ += "azureObjId=" + encodeURIComponent("" + azureObjId) + "&";
        if (includeAccount === null)
            throw new Error("The parameter 'includeAccount' cannot be null.");
        else if (includeAccount !== undefined)
            url_ += "includeAccount=" + encodeURIComponent("" + includeAccount) + "&";
        if (includeJobPositions === null)
            throw new Error("The parameter 'includeJobPositions' cannot be null.");
        else if (includeJobPositions !== undefined)
            url_ += "includeJobPositions=" + encodeURIComponent("" + includeJobPositions) + "&";
        if (includeContactInfo === null)
            throw new Error("The parameter 'includeContactInfo' cannot be null.");
        else if (includeContactInfo !== undefined)
            url_ += "includeContactInfo=" + encodeURIComponent("" + includeContactInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeByAzureObjId(_response);
        });
    }

    protected processGetEmployeeByAzureObjId(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyInfo(): Promise<EmployeeInfoDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/myInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: Response): Promise<EmployeeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployee(body: EmployeeDto | undefined): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployee(_response);
        });
    }

    protected processAddNewEmployee(response: Response): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewEmployeeAccount(employeeId: number, body: EmployeeAccountDto | undefined): Promise<EmployeeAccountDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/EmployeeAccount";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewEmployeeAccount(_response);
        });
    }

    protected processAddNewEmployeeAccount(response: Response): Promise<EmployeeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewJobPosition(employeeId: number, body: JobPositionDto | undefined): Promise<JobPositionDto> {
        let url_ = this.baseUrl + "/api/Employee/VNext/{employeeId}/JobPosition";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewJobPosition(_response);
        });
    }

    protected processAddNewJobPosition(response: Response): Promise<JobPositionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedRequestResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobPosition(id: number, body: JobPositionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JobPosition/VNext/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobPosition(_response);
        });
    }

    protected processDeleteJobPosition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ConcurrencyRequestResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class AlarmDto implements IAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;

    constructor(data?: IAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
}

export class AlarmTimeSpan implements IAlarmTimeSpan {
    months!: number;
    days!: number;
    hours!: number;

    constructor(data?: IAlarmTimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.months = _data["months"];
            this.days = _data["days"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): AlarmTimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["months"] = this.months;
        data["days"] = this.days;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IAlarmTimeSpan {
    months: number;
    days: number;
    hours: number;
}

export enum AlarmType {
    TimeAlarm = "TimeAlarm",
    KmAlarm = "KmAlarm",
}

export class Angle implements IAngle {
    value!: number;
    unit!: AngleUnit;

    constructor(data?: IAngle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Angle {
        data = typeof data === 'object' ? data : {};
        let result = new Angle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IAngle {
    value: number;
    unit: AngleUnit;
}

export enum AngleOffsetType {
    None = "None",
    MinusAlpha = "MinusAlpha",
    PIHalfMinusAlpha = "PIHalfMinusAlpha",
    PiMinusAlpha = "PiMinusAlpha",
    MinusPIHalfMinusAlpha = "MinusPIHalfMinusAlpha",
}

export enum AngleUnit {
    Degree = "Degree",
    Radians = "Radians",
}

export class ArmActionsExecutedStatsResultDto implements IArmActionsExecutedStatsResultDto {
    statDate!: Date;
    data!: ArmatureActionTypeTimePointManyNumberStat[] | undefined;

    constructor(data?: IArmActionsExecutedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArmatureActionTypeTimePointManyNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmActionsExecutedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmActionsExecutedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmActionsExecutedStatsResultDto {
    statDate: Date;
    data: ArmatureActionTypeTimePointManyNumberStat[] | undefined;
}

export enum ArmatureActionType {
    ArmBent = "ArmBent",
    ArmLoaded = "ArmLoaded",
}

export class ArmatureActionTypeTimePointManyNumberStat implements IArmatureActionTypeTimePointManyNumberStat {
    date!: Date;
    stat!: { [key: string]: number; } | undefined;

    constructor(data?: IArmatureActionTypeTimePointManyNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (_data["stat"]) {
                this.stat = {} as any;
                for (let key in _data["stat"]) {
                    if (_data["stat"].hasOwnProperty(key))
                        (<any>this.stat)![key] = _data["stat"][key];
                }
            }
        }
    }

    static fromJS(data: any): ArmatureActionTypeTimePointManyNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new ArmatureActionTypeTimePointManyNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.stat) {
            data["stat"] = {};
            for (let key in this.stat) {
                if (this.stat.hasOwnProperty(key))
                    (<any>data["stat"])[key] = this.stat[key];
            }
        }
        return data;
    }
}

export interface IArmatureActionTypeTimePointManyNumberStat {
    date: Date;
    stat: { [key: string]: number; } | undefined;
}

export enum ArmCardColor {
    White = "White",
    Yellow = "Yellow",
    Orange = "Orange",
    Red = "Red",
    Green = "Green",
    Blue = "Blue",
    DarkBlue = "DarkBlue",
    Pink = "Pink",
    Brown = "Brown",
    Beige = "Beige",
}

export class ArmCardDto implements IArmCardDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    armOrderItemTaskId!: number;
    status!: ArmCardStatus;
    reason!: string | undefined;
    sguid!: string | undefined;
    stripColor!: ArmCardColor;

    constructor(data?: IArmCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.armOrderItemTaskId = _data["armOrderItemTaskId"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.sguid = _data["sguid"];
            this.stripColor = _data["stripColor"];
        }
    }

    static fromJS(data: any): ArmCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["armOrderItemTaskId"] = this.armOrderItemTaskId;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["sguid"] = this.sguid;
        data["stripColor"] = this.stripColor;
        return data;
    }
}

export interface IArmCardDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    armOrderItemTaskId: number;
    status: ArmCardStatus;
    reason: string | undefined;
    sguid: string | undefined;
    stripColor: ArmCardColor;
}

export class ArmCardsCreatedStatsResultDto implements IArmCardsCreatedStatsResultDto {
    statDate!: Date;
    data!: TimePointNumberStat[] | undefined;

    constructor(data?: IArmCardsCreatedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimePointNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmCardsCreatedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmCardsCreatedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmCardsCreatedStatsResultDto {
    statDate: Date;
    data: TimePointNumberStat[] | undefined;
}

export enum ArmCardStatus {
    Active = "Active",
    Cancelled = "Cancelled",
}

export class ArmItemsCreatedStatsResultDto implements IArmItemsCreatedStatsResultDto {
    statDate!: Date;
    data!: TimePointUserNumberStat[] | undefined;

    constructor(data?: IArmItemsCreatedStatsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimePointUserNumberStat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmItemsCreatedStatsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsCreatedStatsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmItemsCreatedStatsResultDto {
    statDate: Date;
    data: TimePointUserNumberStat[] | undefined;
}

export class ArmItemsFinishedByWorkerDto implements IArmItemsFinishedByWorkerDto {
    date!: Date;
    data!: ArmOrderItemDto[] | undefined;

    constructor(data?: IArmItemsFinishedByWorkerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArmOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmItemsFinishedByWorkerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsFinishedByWorkerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmItemsFinishedByWorkerDto {
    date: Date;
    data: ArmOrderItemDto[] | undefined;
}

export class ArmItemsFinishedByWorkerResultDto implements IArmItemsFinishedByWorkerResultDto {
    statDate!: Date;
    data!: { [key: string]: ArmItemsFinishedByWorkerDto[]; } | undefined;

    constructor(data?: IArmItemsFinishedByWorkerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statDate = _data["statDate"] ? new Date(_data["statDate"].toString()) : <any>undefined;
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key] ? _data["data"][key].map((i: any) => ArmItemsFinishedByWorkerDto.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ArmItemsFinishedByWorkerResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmItemsFinishedByWorkerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statDate"] = this.statDate ? this.statDate.toISOString() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        return data;
    }
}

export interface IArmItemsFinishedByWorkerResultDto {
    statDate: Date;
    data: { [key: string]: ArmItemsFinishedByWorkerDto[]; } | undefined;
}

export class ArmModelDto implements IArmModelDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    tags!: string | undefined;
    armTemplate!: ArmTemplate;
    isDeleted!: boolean;

    constructor(data?: IArmModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.tags = _data["tags"];
            this.armTemplate = _data["armTemplate"] ? ArmTemplate.fromJS(_data["armTemplate"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ArmModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["tags"] = this.tags;
        data["armTemplate"] = this.armTemplate ? this.armTemplate.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IArmModelDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    tags: string | undefined;
    armTemplate: ArmTemplate;
    isDeleted: boolean;
}

export class ArmOrderDto implements IArmOrderDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    clientOrderNumber!: number;
    clientId!: number;
    constructionSiteId!: number;
    client!: ClientDto;
    constructionSite!: ConstructionSiteDto;
    items!: ArmOrderItemDto[] | undefined;
    title!: string | undefined;
    description!: string | undefined;
    status!: ArmOrderStatus;

    constructor(data?: IArmOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.clientOrderNumber = _data["clientOrderNumber"];
            this.clientId = _data["clientId"];
            this.constructionSiteId = _data["constructionSiteId"];
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.constructionSite = _data["constructionSite"] ? ConstructionSiteDto.fromJS(_data["constructionSite"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArmOrderItemDto.fromJS(item));
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ArmOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["clientOrderNumber"] = this.clientOrderNumber;
        data["clientId"] = this.clientId;
        data["constructionSiteId"] = this.constructionSiteId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["constructionSite"] = this.constructionSite ? this.constructionSite.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IArmOrderDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    clientOrderNumber: number;
    clientId: number;
    constructionSiteId: number;
    client: ClientDto;
    constructionSite: ConstructionSiteDto;
    items: ArmOrderItemDto[] | undefined;
    title: string | undefined;
    description: string | undefined;
    status: ArmOrderStatus;
}

export class ArmOrderItemDto implements IArmOrderItemDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    internalOrderId!: number;
    orderId!: number;
    armModelTemplateId!: number;
    armModelTemplateParameters!: ArmTemplateParameters;
    position!: string | undefined;
    positionIndex!: string | undefined;
    diameter!: number;
    quantity!: number;
    status!: ArmOrderItemStatus;
    armModelTemplate!: ArmModelDto;

    constructor(data?: IArmOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.internalOrderId = _data["internalOrderId"];
            this.orderId = _data["orderId"];
            this.armModelTemplateId = _data["armModelTemplateId"];
            this.armModelTemplateParameters = _data["armModelTemplateParameters"] ? ArmTemplateParameters.fromJS(_data["armModelTemplateParameters"]) : <any>undefined;
            this.position = _data["position"];
            this.positionIndex = _data["positionIndex"];
            this.diameter = _data["diameter"];
            this.quantity = _data["quantity"];
            this.status = _data["status"];
            this.armModelTemplate = _data["armModelTemplate"] ? ArmModelDto.fromJS(_data["armModelTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["internalOrderId"] = this.internalOrderId;
        data["orderId"] = this.orderId;
        data["armModelTemplateId"] = this.armModelTemplateId;
        data["armModelTemplateParameters"] = this.armModelTemplateParameters ? this.armModelTemplateParameters.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["positionIndex"] = this.positionIndex;
        data["diameter"] = this.diameter;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["armModelTemplate"] = this.armModelTemplate ? this.armModelTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    internalOrderId: number;
    orderId: number;
    armModelTemplateId: number;
    armModelTemplateParameters: ArmTemplateParameters;
    position: string | undefined;
    positionIndex: string | undefined;
    diameter: number;
    quantity: number;
    status: ArmOrderItemStatus;
    armModelTemplate: ArmModelDto;
}

export class ArmOrderItemProductionDataDto implements IArmOrderItemProductionDataDto {
    armOrderItem!: ArmOrderItemDto;
    armOrderItemTask!: ArmOrderItemTaskDto;

    constructor(data?: IArmOrderItemProductionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
            this.armOrderItemTask = _data["armOrderItemTask"] ? ArmOrderItemTaskDto.fromJS(_data["armOrderItemTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemProductionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemProductionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        data["armOrderItemTask"] = this.armOrderItemTask ? this.armOrderItemTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemProductionDataDto {
    armOrderItem: ArmOrderItemDto;
    armOrderItemTask: ArmOrderItemTaskDto;
}

export enum ArmOrderItemStatus {
    New = "New",
}

export class ArmOrderItemTaskDto implements IArmOrderItemTaskDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    armOrderItemId!: number;
    status!: ArmOrderItemTaskStatus;
    cards!: ArmCardDto[] | undefined;
    armOrderItem!: ArmOrderItemDto;

    constructor(data?: IArmOrderItemTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.armOrderItemId = _data["armOrderItemId"];
            this.status = _data["status"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(ArmCardDto.fromJS(item));
            }
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderItemTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderItemTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["armOrderItemId"] = this.armOrderItemId;
        data["status"] = this.status;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmOrderItemTaskDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    armOrderItemId: number;
    status: ArmOrderItemTaskStatus;
    cards: ArmCardDto[] | undefined;
    armOrderItem: ArmOrderItemDto;
}

export enum ArmOrderItemTaskStatus {
    New = "New",
    Active = "Active",
    Bent = "Bent",
    Loaded = "Loaded",
    Completed = "Completed",
}

export class ArmOrderProductionDataDto implements IArmOrderProductionDataDto {
    armOrder!: ArmOrderDto;
    itemsCount!: number;
    itemsInProduction!: number;
    itemsBent!: number;
    itemsDeployed!: number;

    constructor(data?: IArmOrderProductionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            this.itemsCount = _data["itemsCount"];
            this.itemsInProduction = _data["itemsInProduction"];
            this.itemsBent = _data["itemsBent"];
            this.itemsDeployed = _data["itemsDeployed"];
        }
    }

    static fromJS(data: any): ArmOrderProductionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderProductionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        data["itemsCount"] = this.itemsCount;
        data["itemsInProduction"] = this.itemsInProduction;
        data["itemsBent"] = this.itemsBent;
        data["itemsDeployed"] = this.itemsDeployed;
        return data;
    }
}

export interface IArmOrderProductionDataDto {
    armOrder: ArmOrderDto;
    itemsCount: number;
    itemsInProduction: number;
    itemsBent: number;
    itemsDeployed: number;
}

export class ArmOrderProductionDetailDataDto implements IArmOrderProductionDetailDataDto {
    armOrder!: ArmOrderDto;
    items!: ArmOrderItemProductionDataDto[] | undefined;
    infoDate!: Date;

    constructor(data?: IArmOrderProductionDetailDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArmOrderItemProductionDataDto.fromJS(item));
            }
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmOrderProductionDetailDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmOrderProductionDetailDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArmOrderProductionDetailDataDto {
    armOrder: ArmOrderDto;
    items: ArmOrderItemProductionDataDto[] | undefined;
    infoDate: Date;
}

export enum ArmOrderStatus {
    New = "New",
    Pending = "Pending",
    Active = "Active",
    Cancelled = "Cancelled",
    Completed = "Completed",
}

export class ArmParameter implements IArmParameter {
    unitType!: UnitType;
    defaultValue!: any | undefined;
    metadata!: ArmParameterMetadata;

    constructor(data?: IArmParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.defaultValue = _data["defaultValue"];
            this.metadata = _data["metadata"] ? ArmParameterMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["defaultValue"] = this.defaultValue;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmParameter {
    unitType: UnitType;
    defaultValue: any | undefined;
    metadata: ArmParameterMetadata;
}

export class ArmParameterMetadata implements IArmParameterMetadata {
    description!: string | undefined;
    origin!: ArmParameterOrigin;

    constructor(data?: IArmParameterMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.origin = _data["origin"] ? ArmParameterOrigin.fromJS(_data["origin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmParameterMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmParameterMetadata {
    description: string | undefined;
    origin: ArmParameterOrigin;
}

export class ArmParameterOrigin implements IArmParameterOrigin {
    sectionId!: string | undefined;
    sectionParamId!: string | undefined;

    constructor(data?: IArmParameterOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionParamId = _data["sectionParamId"];
        }
    }

    static fromJS(data: any): ArmParameterOrigin {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterOrigin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionParamId"] = this.sectionParamId;
        return data;
    }
}

export interface IArmParameterOrigin {
    sectionId: string | undefined;
    sectionParamId: string | undefined;
}

export class ArmParameterValue implements IArmParameterValue {
    unitType!: UnitType;
    value!: any | undefined;

    constructor(data?: IArmParameterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ArmParameterValue {
        data = typeof data === 'object' ? data : {};
        let result = new ArmParameterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["value"] = this.value;
        return data;
    }
}

export interface IArmParameterValue {
    unitType: UnitType;
    value: any | undefined;
}

export class ArmProductionDetailDataDto implements IArmProductionDetailDataDto {
    orders!: ArmOrderProductionDataDto[] | undefined;
    infoDate!: Date;

    constructor(data?: IArmProductionDetailDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ArmOrderProductionDataDto.fromJS(item));
            }
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmProductionDetailDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArmProductionDetailDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArmProductionDetailDataDto {
    orders: ArmOrderProductionDataDto[] | undefined;
    infoDate: Date;
}

export class ArmSection implements IArmSection {
    id!: string | undefined;
    sectionType!: SectionType;
    parameters!: { [key: string]: SectionParameter; } | undefined;

    constructor(data?: IArmSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionType = _data["sectionType"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] ? SectionParameter.fromJS(_data["parameters"][key]) : new SectionParameter();
                }
            }
        }
    }

    static fromJS(data: any): ArmSection {
        data = typeof data === 'object' ? data : {};
        let result = new ArmSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionType"] = this.sectionType;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IArmSection {
    id: string | undefined;
    sectionType: SectionType;
    parameters: { [key: string]: SectionParameter; } | undefined;
}

export class ArmTemplate implements IArmTemplate {
    parameters!: { [key: string]: ArmParameter; } | undefined;
    variables!: { [key: string]: ArmVariable; } | undefined;
    sections!: ArmSection[] | undefined;

    constructor(data?: IArmTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] ? ArmParameter.fromJS(_data["parameters"][key]) : new ArmParameter();
                }
            }
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (<any>this.variables)![key] = _data["variables"][key] ? ArmVariable.fromJS(_data["variables"][key]) : new ArmVariable();
                }
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ArmSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArmTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ArmTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
            }
        }
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (<any>data["variables"])[key] = this.variables[key] ? this.variables[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArmTemplate {
    parameters: { [key: string]: ArmParameter; } | undefined;
    variables: { [key: string]: ArmVariable; } | undefined;
    sections: ArmSection[] | undefined;
}

export class ArmTemplateParameters implements IArmTemplateParameters {
    parametersValues!: { [key: string]: ArmParameterValue; } | undefined;

    constructor(data?: IArmTemplateParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["parametersValues"]) {
                this.parametersValues = {} as any;
                for (let key in _data["parametersValues"]) {
                    if (_data["parametersValues"].hasOwnProperty(key))
                        (<any>this.parametersValues)![key] = _data["parametersValues"][key] ? ArmParameterValue.fromJS(_data["parametersValues"][key]) : new ArmParameterValue();
                }
            }
        }
    }

    static fromJS(data: any): ArmTemplateParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ArmTemplateParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.parametersValues) {
            data["parametersValues"] = {};
            for (let key in this.parametersValues) {
                if (this.parametersValues.hasOwnProperty(key))
                    (<any>data["parametersValues"])[key] = this.parametersValues[key] ? this.parametersValues[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IArmTemplateParameters {
    parametersValues: { [key: string]: ArmParameterValue; } | undefined;
}

export class ArmVariable implements IArmVariable {
    unitType!: UnitType;
    variableType!: VariableType;
    value!: any | undefined;
    metadata!: ArmVariableMetadata;

    constructor(data?: IArmVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.variableType = _data["variableType"];
            this.value = _data["value"];
            this.metadata = _data["metadata"] ? ArmVariableMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmVariable {
        data = typeof data === 'object' ? data : {};
        let result = new ArmVariable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["variableType"] = this.variableType;
        data["value"] = this.value;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmVariable {
    unitType: UnitType;
    variableType: VariableType;
    value: any | undefined;
    metadata: ArmVariableMetadata;
}

export class ArmVariableMetadata implements IArmVariableMetadata {
    origin!: ArmParameterOrigin;

    constructor(data?: IArmVariableMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? ArmParameterOrigin.fromJS(_data["origin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArmVariableMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ArmVariableMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArmVariableMetadata {
    origin: ArmParameterOrigin;
}

export class AuthenticatedDto implements IAuthenticatedDto {
    employeeInfo!: EmployeeInfoDto;
    token!: string | undefined;
    expirationDate!: Date;

    constructor(data?: IAuthenticatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeInfo = _data["employeeInfo"] ? EmployeeInfoDto.fromJS(_data["employeeInfo"]) : <any>undefined;
            this.token = _data["token"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeInfo"] = this.employeeInfo ? this.employeeInfo.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthenticatedDto {
    employeeInfo: EmployeeInfoDto;
    token: string | undefined;
    expirationDate: Date;
}

export class BadRequestResponse implements IBadRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IBadRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): BadRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IBadRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export class CarDto implements ICarDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    amortisation!: number;
    depreciationPeriod!: number;
    isDeleted!: boolean;
    productionDate!: Date;
    data!: any | undefined;
    engineType!: EngineType;

    constructor(data?: ICarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.amortisation = _data["amortisation"];
            this.depreciationPeriod = _data["depreciationPeriod"];
            this.isDeleted = _data["isDeleted"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): CarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["amortisation"] = this.amortisation;
        data["depreciationPeriod"] = this.depreciationPeriod;
        data["isDeleted"] = this.isDeleted;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface ICarDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    amortisation: number;
    depreciationPeriod: number;
    isDeleted: boolean;
    productionDate: Date;
    data: any | undefined;
    engineType: EngineType;
}

export enum LoadFragilityCategory {
    Fragile = "Fragile",
    Sturdy = "Sturdy",
    Valuable = "Valuable",
    Pointy = "Pointy",
    Sharp = "Sharp",
}

export enum LoadType {
    Armature = "Armature",
    BuildingMaterials = "BuildingMaterials",
}

export class ChangePasswordDto implements IChangePasswordDto {
    employeeAccount!: EmployeeAccountDto;
    newPassword!: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    employeeAccount: EmployeeAccountDto;
    newPassword: string | undefined;
}

export class ClientDocumentDto implements IClientDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    clientId!: number;

    constructor(data?: IClientDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ClientDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IClientDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    clientId: number;
}

export class ClientDto implements IClientDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    clientEntityType!: ClientEntityType;
    clientType!: ClientType;
    name!: string | undefined;
    shortName!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    ucin!: string | undefined;
    taxId!: string | undefined;
    contactInfo!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.clientEntityType = _data["clientEntityType"];
            this.clientType = _data["clientType"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.ucin = _data["ucin"];
            this.taxId = _data["taxId"];
            this.contactInfo = _data["contactInfo"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["clientEntityType"] = this.clientEntityType;
        data["clientType"] = this.clientType;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["ucin"] = this.ucin;
        data["taxId"] = this.taxId;
        data["contactInfo"] = this.contactInfo;
        data["email"] = this.email;
        return data;
    }
}

export interface IClientDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    clientEntityType: ClientEntityType;
    clientType: ClientType;
    name: string | undefined;
    shortName: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    city: string | undefined;
    ucin: string | undefined;
    taxId: string | undefined;
    contactInfo: string | undefined;
    email: string | undefined;
}

export enum ClientEntityType {
    Legal = "Legal",
    Physical = "Physical",
}

export class ClientRecordDto implements IClientRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    clientId!: number;

    constructor(data?: IClientRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ClientRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IClientRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    clientId: number;
}

export enum ClientType {
    Customer = "Customer",
    Service = "Service",
    Supplier = "Supplier",
}

export class CompositionDto implements ICompositionDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    mainVehicleId!: number;
    trailersIds!: number[] | undefined;
    workingMachinesIds!: number[] | undefined;
    data!: any | undefined;

    constructor(data?: ICompositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.mainVehicleId = _data["mainVehicleId"];
            if (Array.isArray(_data["trailersIds"])) {
                this.trailersIds = [] as any;
                for (let item of _data["trailersIds"])
                    this.trailersIds!.push(item);
            }
            if (Array.isArray(_data["workingMachinesIds"])) {
                this.workingMachinesIds = [] as any;
                for (let item of _data["workingMachinesIds"])
                    this.workingMachinesIds!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CompositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["mainVehicleId"] = this.mainVehicleId;
        if (Array.isArray(this.trailersIds)) {
            data["trailersIds"] = [];
            for (let item of this.trailersIds)
                data["trailersIds"].push(item);
        }
        if (Array.isArray(this.workingMachinesIds)) {
            data["workingMachinesIds"] = [];
            for (let item of this.workingMachinesIds)
                data["workingMachinesIds"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface ICompositionDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    mainVehicleId: number;
    trailersIds: number[] | undefined;
    workingMachinesIds: number[] | undefined;
    data: any | undefined;
}

export class ConcurrencyRequestResponse implements IConcurrencyRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IConcurrencyRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): ConcurrencyRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrencyRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IConcurrencyRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export class ConfigDto implements IConfigDto {
    googleConfig!: GoogleConfigDto;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleConfig = _data["googleConfig"] ? GoogleConfigDto.fromJS(_data["googleConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleConfig"] = this.googleConfig ? this.googleConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigDto {
    googleConfig: GoogleConfigDto;
}

export class ConstructionSiteDto implements IConstructionSiteDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    data!: any | undefined;
    locationInfo!: any | undefined;
    projectId!: number;
    project!: ProjectDto;

    constructor(data?: IConstructionSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.locationInfo = _data["locationInfo"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConstructionSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        data["data"] = this.data;
        data["locationInfo"] = this.locationInfo;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConstructionSiteDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    data: any | undefined;
    locationInfo: any | undefined;
    projectId: number;
    project: ProjectDto;
}

export enum ContactInfoType {
    Viber = "Viber",
}

export class CreateArmCardRequestDto implements ICreateArmCardRequestDto {
    reason!: string | undefined;
    stripColor!: ArmCardColor;

    constructor(data?: ICreateArmCardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.stripColor = _data["stripColor"];
        }
    }

    static fromJS(data: any): CreateArmCardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArmCardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["stripColor"] = this.stripColor;
        return data;
    }
}

export interface ICreateArmCardRequestDto {
    reason: string | undefined;
    stripColor: ArmCardColor;
}

export class DocumentDto implements IDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
}

export class DriverDto implements IDriverDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    azObjId!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;
    personalNumber!: string | undefined;
    ucin!: string | undefined;
    birthDate!: Date;
    employeeAccount!: EmployeeAccountDto;
    jobPositions!: JobPositionDto[] | undefined;
    contactInfos!: EmployeeContactInfoDto[] | undefined;
    data!: any | undefined;
    tcNumber!: string | undefined;
    driverPositionId!: number;
    driverPositionTimeStamp!: string | undefined;

    constructor(data?: IDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.azObjId = _data["azObjId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalNumber = _data["personalNumber"];
            this.ucin = _data["ucin"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            if (Array.isArray(_data["jobPositions"])) {
                this.jobPositions = [] as any;
                for (let item of _data["jobPositions"])
                    this.jobPositions!.push(JobPositionDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(EmployeeContactInfoDto.fromJS(item));
            }
            this.data = _data["data"];
            this.tcNumber = _data["tcNumber"];
            this.driverPositionId = _data["driverPositionId"];
            this.driverPositionTimeStamp = _data["driverPositionTimeStamp"];
        }
    }

    static fromJS(data: any): DriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["azObjId"] = this.azObjId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["personalNumber"] = this.personalNumber;
        data["ucin"] = this.ucin;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.jobPositions)) {
            data["jobPositions"] = [];
            for (let item of this.jobPositions)
                data["jobPositions"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        data["data"] = this.data;
        data["tcNumber"] = this.tcNumber;
        data["driverPositionId"] = this.driverPositionId;
        data["driverPositionTimeStamp"] = this.driverPositionTimeStamp;
        return data;
    }
}

export interface IDriverDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    azObjId: string | undefined;
    name: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    personalNumber: string | undefined;
    ucin: string | undefined;
    birthDate: Date;
    employeeAccount: EmployeeAccountDto;
    jobPositions: JobPositionDto[] | undefined;
    contactInfos: EmployeeContactInfoDto[] | undefined;
    data: any | undefined;
    tcNumber: string | undefined;
    driverPositionId: number;
    driverPositionTimeStamp: string | undefined;
}

export class EmployeeAccountDto implements IEmployeeAccountDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    employeeId!: number;
    username!: string | undefined;
    password!: string | undefined;

    constructor(data?: IEmployeeAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): EmployeeAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IEmployeeAccountDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    employeeId: number;
    username: string | undefined;
    password: string | undefined;
}

export class EmployeeContactInfoDto implements IEmployeeContactInfoDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    type!: ContactInfoType;
    contactId!: string | undefined;
    contactName!: string | undefined;
    contactAvatar!: string | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactAvatar = _data["contactAvatar"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["type"] = this.type;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactAvatar"] = this.contactAvatar;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeContactInfoDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    type: ContactInfoType;
    contactId: string | undefined;
    contactName: string | undefined;
    contactAvatar: string | undefined;
    employeeId: number;
}

export class EmployeeDocumentDto implements IEmployeeDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    employeeId: number;
}

export class EmployeeDto implements IEmployeeDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    azObjId!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;
    personalNumber!: string | undefined;
    ucin!: string | undefined;
    birthDate!: Date;
    employeeAccount!: EmployeeAccountDto;
    jobPositions!: JobPositionDto[] | undefined;
    contactInfos!: EmployeeContactInfoDto[] | undefined;
    data!: any | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.azObjId = _data["azObjId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalNumber = _data["personalNumber"];
            this.ucin = _data["ucin"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.employeeAccount = _data["employeeAccount"] ? EmployeeAccountDto.fromJS(_data["employeeAccount"]) : <any>undefined;
            if (Array.isArray(_data["jobPositions"])) {
                this.jobPositions = [] as any;
                for (let item of _data["jobPositions"])
                    this.jobPositions!.push(JobPositionDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(EmployeeContactInfoDto.fromJS(item));
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["azObjId"] = this.azObjId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["personalNumber"] = this.personalNumber;
        data["ucin"] = this.ucin;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["employeeAccount"] = this.employeeAccount ? this.employeeAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.jobPositions)) {
            data["jobPositions"] = [];
            for (let item of this.jobPositions)
                data["jobPositions"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IEmployeeDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    azObjId: string | undefined;
    name: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    personalNumber: string | undefined;
    ucin: string | undefined;
    birthDate: Date;
    employeeAccount: EmployeeAccountDto;
    jobPositions: JobPositionDto[] | undefined;
    contactInfos: EmployeeContactInfoDto[] | undefined;
    data: any | undefined;
}

export class EmployeeInfoDto implements IEmployeeInfoDto {
    employee!: EmployeeDto;
    roles!: string[] | undefined;

    constructor(data?: IEmployeeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IEmployeeInfoDto {
    employee: EmployeeDto;
    roles: string[] | undefined;
}

export class EmployeeRecordDto implements IEmployeeRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    employeeId: number;
}

export enum EngineType {
    Gasoline = "Gasoline",
    Diesel = "Diesel",
    LNG = "LNG",
    LPG = "LPG",
    CNG = "CNG",
    Electric = "Electric",
}

export enum EntityType {
    Record = "Record",
    Expense = "Expense",
    Vehicle = "Vehicle",
    WorkingMachine = "WorkingMachine",
    Employee = "Employee",
    Client = "Client",
    Event = "Event",
    Task = "Task",
}

export class EventDto implements IEventDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    notificationMedia!: NotificationMedia;
    userScope!: UserScope;
    entityType!: EntityType;
    entityId!: number;
    userGroup!: UserGroupDto;
    userGroupId!: number;
    isDone!: boolean;
    data!: any | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.notificationMedia = _data["notificationMedia"];
            this.userScope = _data["userScope"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.userGroup = _data["userGroup"] ? UserGroupDto.fromJS(_data["userGroup"]) : <any>undefined;
            this.userGroupId = _data["userGroupId"];
            this.isDone = _data["isDone"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["notificationMedia"] = this.notificationMedia;
        data["userScope"] = this.userScope;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["userGroup"] = this.userGroup ? this.userGroup.toJSON() : <any>undefined;
        data["userGroupId"] = this.userGroupId;
        data["isDone"] = this.isDone;
        data["data"] = this.data;
        return data;
    }
}

export interface IEventDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    notificationMedia: NotificationMedia;
    userScope: UserScope;
    entityType: EntityType;
    entityId: number;
    userGroup: UserGroupDto;
    userGroupId: number;
    isDone: boolean;
    data: any | undefined;
}

export class EventTimeSpan implements IEventTimeSpan {
    months!: number;
    days!: number;

    constructor(data?: IEventTimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.months = _data["months"];
            this.days = _data["days"];
        }
    }

    static fromJS(data: any): EventTimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["months"] = this.months;
        data["days"] = this.days;
        return data;
    }
}

export interface IEventTimeSpan {
    months: number;
    days: number;
}

export class TimeEventDto implements ITimeEventDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    notificationMedia!: NotificationMedia;
    userScope!: UserScope;
    entityType!: EntityType;
    entityId!: number;
    userGroup!: UserGroupDto;
    userGroupId!: number;
    isDone!: boolean;
    data!: any | undefined;
    startingDate!: Date | undefined;
    ringDate!: Date | undefined;
    inTimeRing!: EventTimeSpan;
    marginInDays!: number;

    constructor(data?: ITimeEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.notificationMedia = _data["notificationMedia"];
            this.userScope = _data["userScope"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.userGroup = _data["userGroup"] ? UserGroupDto.fromJS(_data["userGroup"]) : <any>undefined;
            this.userGroupId = _data["userGroupId"];
            this.isDone = _data["isDone"];
            this.data = _data["data"];
            this.startingDate = _data["startingDate"] ? new Date(_data["startingDate"].toString()) : <any>undefined;
            this.ringDate = _data["ringDate"] ? new Date(_data["ringDate"].toString()) : <any>undefined;
            this.inTimeRing = _data["inTimeRing"] ? EventTimeSpan.fromJS(_data["inTimeRing"]) : <any>undefined;
            this.marginInDays = _data["marginInDays"];
        }
    }

    static fromJS(data: any): TimeEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["notificationMedia"] = this.notificationMedia;
        data["userScope"] = this.userScope;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["userGroup"] = this.userGroup ? this.userGroup.toJSON() : <any>undefined;
        data["userGroupId"] = this.userGroupId;
        data["isDone"] = this.isDone;
        data["data"] = this.data;
        data["startingDate"] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data["ringDate"] = this.ringDate ? this.ringDate.toISOString() : <any>undefined;
        data["inTimeRing"] = this.inTimeRing ? this.inTimeRing.toJSON() : <any>undefined;
        data["marginInDays"] = this.marginInDays;
        return data;
    }
}
    
export interface ITimeEventDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    notificationMedia: NotificationMedia;
    userScope: UserScope;
    entityType: EntityType;
    entityId: number;
    userGroup: UserGroupDto;
    userGroupId: number;
    isDone: boolean;
    data: any | undefined;
    startingDate: Date | undefined;
    ringDate: Date | undefined;
    inTimeRing: EventTimeSpan;
    marginInDays: number;
}

export class KmEventDto implements IKmEventDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    notificationMedia!: NotificationMedia;
    userScope!: UserScope;
    entityType!: EntityType;
    entityId!: number;
    userGroup!: UserGroupDto;
    userGroupId!: number;
    isDone!: boolean;
    data!: any | undefined;
    startingDate!: Date | undefined;
    kmWhenToRing!: number | undefined;
    inKmToRing!: number | undefined;
    kmMargin!: number | undefined;

    constructor(data?: IKmEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.notificationMedia = _data["notificationMedia"];
            this.userScope = _data["userScope"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.userGroup = _data["userGroup"] ? UserGroupDto.fromJS(_data["userGroup"]) : <any>undefined;
            this.userGroupId = _data["userGroupId"];
            this.isDone = _data["isDone"];
            this.data = _data["data"];
            this.startingDate = _data["startingDate"];
            this.kmWhenToRing = _data["kmWhenToRing"];
            this.inKmToRing = _data["inKmToRing"];
            this.kmMargin = _data["kmMargin"];
        }
    }

    static fromJS(data: any): KmEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new KmEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["notificationMedia"] = this.notificationMedia;
        data["userScope"] = this.userScope;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["userGroup"] = this.userGroup ? this.userGroup.toJSON() : <any>undefined;
        data["userGroupId"] = this.userGroupId;
        data["isDone"] = this.isDone;
        data["data"] = this.data;
        data["startingDate"] = this.startingDate;
        data["kmWhenToRing"] = this.kmWhenToRing;
        data["inKmToRing"] = this.inKmToRing;
        data["kmMargin"] = this.kmMargin;
        return data;
    }
}

export interface IKmEventDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    notificationMedia: NotificationMedia;
    userScope: UserScope;
    entityType: EntityType;
    entityId: number;
    userGroup: UserGroupDto;
    userGroupId: number;
    isDone: boolean;
    data: any | undefined;
    startingDate: Date | undefined;
    kmWhenToRing: number | undefined;
    inKmToRing: number | undefined;
    kmMargin: number | undefined;
}

export class ExecuteActionRequestDto implements IExecuteActionRequestDto {
    actionCode!: string | undefined;
    onBehalfEmployee!: number;
    originated!: Date;

    constructor(data?: IExecuteActionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.onBehalfEmployee = _data["onBehalfEmployee"];
            this.originated = _data["originated"] ? new Date(_data["originated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExecuteActionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["onBehalfEmployee"] = this.onBehalfEmployee;
        data["originated"] = this.originated ? this.originated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExecuteActionRequestDto {
    actionCode: string | undefined;
    onBehalfEmployee: number;
    originated: Date;
}

export class ExecuteActionResponseDto implements IExecuteActionResponseDto {
    armOrderItem!: ArmOrderItemDto;
    armOrder!: ArmOrderDto;
    actionType!: ArmatureActionType;

    constructor(data?: IExecuteActionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armOrderItem = _data["armOrderItem"] ? ArmOrderItemDto.fromJS(_data["armOrderItem"]) : <any>undefined;
            this.armOrder = _data["armOrder"] ? ArmOrderDto.fromJS(_data["armOrder"]) : <any>undefined;
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): ExecuteActionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armOrderItem"] = this.armOrderItem ? this.armOrderItem.toJSON() : <any>undefined;
        data["armOrder"] = this.armOrder ? this.armOrder.toJSON() : <any>undefined;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface IExecuteActionResponseDto {
    armOrderItem: ArmOrderItemDto;
    armOrder: ArmOrderDto;
    actionType: ArmatureActionType;
}

export enum ExpenseCategory {
    Fuel = "Fuel",
    Other = "Other",
    RepairAndMaintenance = "RepairAndMaintenance",
    RecurringExpense = "RecurringExpense",
    CalculatorExpense = "CalculatorExpense",
}

export class ExpenseTypeDto implements IExpenseTypeDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    expenseCategory!: ExpenseCategory;
    expenseSubCategory!: string | undefined;
    durationInMonths!: number | undefined;
    durationInKm!: number | undefined;

    constructor(data?: IExpenseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.expenseCategory = _data["expenseCategory"];
            this.expenseSubCategory = _data["expenseSubCategory"];
            this.durationInMonths = _data["durationInMonths"];
            this.durationInKm = _data["durationInKm"];
        }
    }

    static fromJS(data: any): ExpenseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["expenseCategory"] = this.expenseCategory;
        data["expenseSubCategory"] = this.expenseSubCategory;
        data["durationInMonths"] = this.durationInMonths;
        data["durationInKm"] = this.durationInKm;
        return data;
    }
}

export interface IExpenseTypeDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    expenseCategory: ExpenseCategory;
    expenseSubCategory: string | undefined;
    durationInMonths: number | undefined;
    durationInKm: number | undefined;
}

export class FuelSumsDto implements IFuelSumsDto {
    date!: Date;
    value!: number;
    currentVehicleKm!: number | undefined;
    kmDifference!: number | undefined;
    averageFuelConsumptionPerOneHundredKm!: number | undefined;
    step!: number | undefined;

    constructor(data?: IFuelSumsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.currentVehicleKm = _data["currentVehicleKm"];
            this.kmDifference = _data["kmDifference"];
            this.averageFuelConsumptionPerOneHundredKm = _data["averageFuelConsumptionPerOneHundredKm"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): FuelSumsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelSumsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["currentVehicleKm"] = this.currentVehicleKm;
        data["kmDifference"] = this.kmDifference;
        data["averageFuelConsumptionPerOneHundredKm"] = this.averageFuelConsumptionPerOneHundredKm;
        data["step"] = this.step;
        return data;
    }
}

export interface IFuelSumsDto {
    date: Date;
    value: number;
    currentVehicleKm: number | undefined;
    kmDifference: number | undefined;
    averageFuelConsumptionPerOneHundredKm: number | undefined;
    step: number | undefined;
}

export class GetProductionDataRefreshInfoResponseDto implements IGetProductionDataRefreshInfoResponseDto {
    infoDate!: Date | undefined;

    constructor(data?: IGetProductionDataRefreshInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoDate = _data["infoDate"] ? new Date(_data["infoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductionDataRefreshInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionDataRefreshInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetProductionDataRefreshInfoResponseDto {
    infoDate: Date | undefined;
}

export class GoogleConfigDto implements IGoogleConfigDto {
    apiKey!: string | undefined;

    constructor(data?: IGoogleConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): GoogleConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IGoogleConfigDto {
    apiKey: string | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    description!: string | undefined;
    code!: string | undefined;
    creationDate!: Date;
    data!: any | undefined;
    clientId!: number;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["description"] = this.description;
        data["code"] = this.code;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IInvoiceDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    description: string | undefined;
    code: string | undefined;
    creationDate: Date;
    data: any | undefined;
    clientId: number;
}

export class JobPositionDto implements IJobPositionDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    employeeId!: number;
    jobPositionType!: JobPositionType;
    data!: any | undefined;

    constructor(data?: IJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.jobPositionType = _data["jobPositionType"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): JobPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["jobPositionType"] = this.jobPositionType;
        data["data"] = this.data;
        return data;
    }
}

export interface IJobPositionDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    employeeId: number;
    jobPositionType: JobPositionType;
    data: any | undefined;
}

export enum JobPositionType {
    Driver = "Driver",
    TransportOperator = "TransportOperator",
    ArmatureWorker = "ArmatureWorker",
    ArmatureOperator = "ArmatureOperator",
    SystemAdmin = "SystemAdmin",
    CEO = "CEO",
}

export class KmAlarmDto implements IKmAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;
    inKmToRing!: number | undefined;
    kmWhenToRing!: number | undefined;

    constructor(data?: IKmAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
            this.inKmToRing = _data["inKmToRing"];
            this.kmWhenToRing = _data["kmWhenToRing"];
        }
    }

    static fromJS(data: any): KmAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new KmAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        data["inKmToRing"] = this.inKmToRing;
        data["kmWhenToRing"] = this.kmWhenToRing;
        return data;
    }
}

export interface IKmAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
    inKmToRing: number | undefined;
    kmWhenToRing: number | undefined;
}

export class Length implements ILength {
    value!: number;
    unit!: LengthUnit;

    constructor(data?: ILength) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Length {
        data = typeof data === 'object' ? data : {};
        let result = new Length();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface ILength {
    value: number;
    unit: LengthUnit;
}

export enum LengthUnit {
    Meter = "Meter",
    Milimeter = "Milimeter",
    Centimeter = "Centimeter",
}

export enum MachineType {
    WorkingMachine = "WorkingMachine",
    HandMachine = "HandMachine",
    OfficeMachine = "OfficeMachine",
    WorkingTool = "WorkingTool",
}

export class NotificationDto implements INotificationDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    notificationMedia!: NotificationMedia;
    entityType!: EntityType;
    entityId!: number;
    userGroupId!: number;
    userGroup!: UserGroupDto;
    seen!: boolean;
    closed!: boolean;
    data!: any | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.notificationMedia = _data["notificationMedia"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.userGroupId = _data["userGroupId"];
            this.userGroup = _data["userGroup"] ? UserGroupDto.fromJS(_data["userGroup"]) : <any>undefined;
            this.seen = _data["seen"];
            this.closed = _data["closed"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["notificationMedia"] = this.notificationMedia;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["userGroupId"] = this.userGroupId;
        data["userGroup"] = this.userGroup ? this.userGroup.toJSON() : <any>undefined;
        data["seen"] = this.seen;
        data["closed"] = this.closed;
        data["data"] = this.data;
        return data;
    }
}

export interface INotificationDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    notificationMedia: NotificationMedia;
    entityType: EntityType;
    entityId: number;
    userGroupId: number;
    userGroup: UserGroupDto;
    seen: boolean;
    closed: boolean;
    data: any | undefined;
}

export enum NotificationMedia {
    Armature = "Armature",
    Transport = "Transport",
    Viber = "Viber",
}

export class NotificationsSearchToken implements INotificationsSearchToken {
    lastEntityId!: number | undefined;
    numberOfEntitiesToReturn!: number;

    constructor(data?: INotificationsSearchToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastEntityId = _data["lastEntityId"];
            this.numberOfEntitiesToReturn = _data["numberOfEntitiesToReturn"];
        }
    }

    static fromJS(data: any): NotificationsSearchToken {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationsSearchToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastEntityId"] = this.lastEntityId;
        data["numberOfEntitiesToReturn"] = this.numberOfEntitiesToReturn;
        return data;
    }
}

export interface INotificationsSearchToken {
    lastEntityId: number | undefined;
    numberOfEntitiesToReturn: number;
}

export enum ParameterRefType {
    Parameter = "Parameter",
    Variables = "Variables",
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export class ProjectDto implements IProjectDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    data!: any | undefined;
    constructionSites!: ConstructionSiteDto[] | undefined;
    clientId!: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.data = _data["data"];
            if (Array.isArray(_data["constructionSites"])) {
                this.constructionSites = [] as any;
                for (let item of _data["constructionSites"])
                    this.constructionSites!.push(ConstructionSiteDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        data["data"] = this.data;
        if (Array.isArray(this.constructionSites)) {
            data["constructionSites"] = [];
            for (let item of this.constructionSites)
                data["constructionSites"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IProjectDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    data: any | undefined;
    constructionSites: ConstructionSiteDto[] | undefined;
    clientId: number;
}

export enum RecordCategory {
    ImportantDocs = "ImportantDocs",
    Record = "Record",
    Expense = "Expense",
    Other = "Other",
}

export class RecordDocumentDto implements IRecordDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    recordId!: number;

    constructor(data?: IRecordDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): RecordDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["recordId"] = this.recordId;
        return data;
    }
}

export interface IRecordDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    recordId: number;
}

export class RecordDto implements IRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
}

export enum RequestOriginApp {
    Armature = "Armature",
    Warehouse = "Warehouse",
    Transport = "Transport",
}

export class SectionParameter implements ISectionParameter {
    unitType!: UnitType;
    refType!: ParameterRefType;
    value!: string | undefined;

    constructor(data?: ISectionParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"];
            this.refType = _data["refType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SectionParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SectionParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["refType"] = this.refType;
        data["value"] = this.value;
        return data;
    }
}

export interface ISectionParameter {
    unitType: UnitType;
    refType: ParameterRefType;
    value: string | undefined;
}

export enum SectionType {
    Line = "Line",
    Circle = "Circle",
}

export class ShipmentDto implements IShipmentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    loadValue!: number;
    loadWeight!: number;
    loadVolume!: number;
    loadPalletSpaces!: number;
    transportPrice!: number;
    urgency!: Urgency;
    loadType!: LoadType;
    loadFragilityCategory!: LoadFragilityCategory;
    requestOriginApp!: RequestOriginApp;
    shipmentStatus!: ShipmentStatus;
    note!: string | undefined;
    startingStopId!: number;
    startingStop!: StopDto;
    endingStopId!: number;
    endingStop!: StopDto;
    data!: any | undefined;

    constructor(data?: IShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.loadValue = _data["loadValue"];
            this.loadWeight = _data["loadWeight"];
            this.loadVolume = _data["loadVolume"];
            this.loadPalletSpaces = _data["loadPalletSpaces"];
            this.transportPrice = _data["transportPrice"];
            this.urgency = _data["urgency"];
            this.loadType = _data["loadType"];
            this.loadFragilityCategory = _data["loadFragilityCategory"];
            this.requestOriginApp = _data["requestOriginApp"];
            this.shipmentStatus = _data["shipmentStatus"];
            this.note = _data["note"];
            this.startingStopId = _data["startingStopId"];
            this.startingStop = _data["startingStop"] ? StopDto.fromJS(_data["startingStop"]) : <any>undefined;
            this.endingStopId = _data["endingStopId"];
            this.endingStop = _data["endingStop"] ? StopDto.fromJS(_data["endingStop"]) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["loadValue"] = this.loadValue;
        data["loadWeight"] = this.loadWeight;
        data["loadVolume"] = this.loadVolume;
        data["loadPalletSpaces"] = this.loadPalletSpaces;
        data["transportPrice"] = this.transportPrice;
        data["urgency"] = this.urgency;
        data["loadType"] = this.loadType;
        data["loadFragilityCategory"] = this.loadFragilityCategory;
        data["requestOriginApp"] = this.requestOriginApp;
        data["shipmentStatus"] = this.shipmentStatus;
        data["note"] = this.note;
        data["startingStopId"] = this.startingStopId;
        data["startingStop"] = this.startingStop ? this.startingStop.toJSON() : <any>undefined;
        data["endingStopId"] = this.endingStopId;
        data["endingStop"] = this.endingStop ? this.endingStop.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IShipmentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    loadValue: number;
    loadWeight: number;
    loadVolume: number;
    loadPalletSpaces: number;
    transportPrice: number;
    urgency: Urgency;
    loadType: LoadType;
    loadFragilityCategory: LoadFragilityCategory;
    requestOriginApp: RequestOriginApp;
    shipmentStatus: ShipmentStatus;
    note: string | undefined;
    startingStopId: number;
    startingStop: StopDto;
    endingStopId: number;
    endingStop: StopDto;
    data: any | undefined;
}

export enum ShipmentStatus {
    Pending = "Pending",
    PreTransit = "PreTransit",
    Loading = "Loading",
    Loaded = "Loaded",
    InTransit = "InTransit",
    OutForDelivery = "OutForDelivery",
    Delivered = "Delivered",
    Returned = "Returned",
    Unloaded = "Unloaded",
    Exception = "Exception",
}

export enum StatGranulation {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export class StopDto implements IStopDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    stopType!: StopType;
    startingTime!: Date;
    endingTime!: Date;
    locationInfo!: any | undefined;
    note!: string | undefined;
    data!: any | undefined;

    constructor(data?: IStopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.stopType = _data["stopType"];
            this.startingTime = _data["startingTime"] ? new Date(_data["startingTime"].toString()) : <any>undefined;
            this.endingTime = _data["endingTime"] ? new Date(_data["endingTime"].toString()) : <any>undefined;
            this.locationInfo = _data["locationInfo"];
            this.note = _data["note"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): StopDto {
        data = typeof data === 'object' ? data : {};
        let result = new StopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        data["stopType"] = this.stopType;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString() : <any>undefined;
        data["endingTime"] = this.endingTime ? this.endingTime.toISOString() : <any>undefined;
        data["locationInfo"] = this.locationInfo;
        data["note"] = this.note;
        data["data"] = this.data;
        return data;
    }
}

export interface IStopDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    stopType: StopType;
    startingTime: Date;
    endingTime: Date;
    locationInfo: any | undefined;
    note: string | undefined;
    data: any | undefined;
}

export enum StopType {
    Loading = "Loading",
    Unloading = "Unloading",
    Idle = "Idle",
}

export class SumsDto implements ISumsDto {
    date!: Date;
    value!: number;

    constructor(data?: ISumsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SumsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SumsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ISumsDto {
    date: Date;
    value: number;
}

export enum SumType {
    Monthly = "Monthly",
    Weekly = "Weekly",
}

export class TimeAlarmDto implements ITimeAlarmDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    data!: any | undefined;
    isDone!: boolean;
    alarmType!: AlarmType;
    vehicles!: VehicleDto[] | undefined;
    records!: RecordDto[] | undefined;
    drivers!: DriverDto[] | undefined;
    workingMachines!: WorkingMachineDto[] | undefined;
    ringDate!: Date | undefined;
    inTimeRing!: AlarmTimeSpan;

    constructor(data?: ITimeAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isDone = _data["isDone"];
            this.alarmType = _data["alarmType"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordDto.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(DriverDto.fromJS(item));
            }
            if (Array.isArray(_data["workingMachines"])) {
                this.workingMachines = [] as any;
                for (let item of _data["workingMachines"])
                    this.workingMachines!.push(WorkingMachineDto.fromJS(item));
            }
            this.ringDate = _data["ringDate"] ? new Date(_data["ringDate"].toString()) : <any>undefined;
            this.inTimeRing = _data["inTimeRing"] ? AlarmTimeSpan.fromJS(_data["inTimeRing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isDone"] = this.isDone;
        data["alarmType"] = this.alarmType;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.workingMachines)) {
            data["workingMachines"] = [];
            for (let item of this.workingMachines)
                data["workingMachines"].push(item.toJSON());
        }
        data["ringDate"] = this.ringDate ? this.ringDate.toISOString() : <any>undefined;
        data["inTimeRing"] = this.inTimeRing ? this.inTimeRing.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeAlarmDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    title: string | undefined;
    description: string | undefined;
    data: any | undefined;
    isDone: boolean;
    alarmType: AlarmType;
    vehicles: VehicleDto[] | undefined;
    records: RecordDto[] | undefined;
    drivers: DriverDto[] | undefined;
    workingMachines: WorkingMachineDto[] | undefined;
    ringDate: Date | undefined;
    inTimeRing: AlarmTimeSpan;
}

export class TimePointNumberStat implements ITimePointNumberStat {
    date!: Date;
    quantity!: number;

    constructor(data?: ITimePointNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TimePointNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new TimePointNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ITimePointNumberStat {
    date: Date;
    quantity: number;
}

export class TimePointUserNumberStat implements ITimePointUserNumberStat {
    date!: Date;
    statByUser!: { [key: string]: number; } | undefined;

    constructor(data?: ITimePointUserNumberStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (_data["statByUser"]) {
                this.statByUser = {} as any;
                for (let key in _data["statByUser"]) {
                    if (_data["statByUser"].hasOwnProperty(key))
                        (<any>this.statByUser)![key] = _data["statByUser"][key];
                }
            }
        }
    }

    static fromJS(data: any): TimePointUserNumberStat {
        data = typeof data === 'object' ? data : {};
        let result = new TimePointUserNumberStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.statByUser) {
            data["statByUser"] = {};
            for (let key in this.statByUser) {
                if (this.statByUser.hasOwnProperty(key))
                    (<any>data["statByUser"])[key] = this.statByUser[key];
            }
        }
        return data;
    }
}

export interface ITimePointUserNumberStat {
    date: Date;
    statByUser: { [key: string]: number; } | undefined;
}

export class TrailerDto implements ITrailerDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    amortisation!: number;
    depreciationPeriod!: number;
    productionDate!: Date;
    data!: any | undefined;
    isDeleted!: boolean;
    trailerType!: TrailerType;
    loadWeight!: number;
    loadVolume!: number;
    loadPalletSpaces!: number;

    constructor(data?: ITrailerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.amortisation = _data["amortisation"];
            this.depreciationPeriod = _data["depreciationPeriod"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.isDeleted = _data["isDeleted"];
            this.trailerType = _data["trailerType"];
            this.loadWeight = _data["loadWeight"];
            this.loadVolume = _data["loadVolume"];
            this.loadPalletSpaces = _data["loadPalletSpaces"];
        }
    }

    static fromJS(data: any): TrailerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrailerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["amortisation"] = this.amortisation;
        data["depreciationPeriod"] = this.depreciationPeriod;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["isDeleted"] = this.isDeleted;
        data["trailerType"] = this.trailerType;
        data["loadWeight"] = this.loadWeight;
        data["loadVolume"] = this.loadVolume;
        data["loadPalletSpaces"] = this.loadPalletSpaces;
        return data;
    }
}

export interface ITrailerDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    amortisation: number;
    depreciationPeriod: number;
    productionDate: Date;
    data: any | undefined;
    isDeleted: boolean;
    trailerType: TrailerType;
    loadWeight: number;
    loadVolume: number;
    loadPalletSpaces: number;
}

export enum TrailerType {
    RegularTrailer = "RegularTrailer",
    SemiTrailer = "SemiTrailer",
}

export class TransportWarrantDto implements ITransportWarrantDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    isTwFinished!: boolean;
    estStartingTime!: Date;
    estEndingTime!: Date;
    actStartingTime!: Date;
    actEndingTime!: Date;
    transportWarrantStatus!: TransportWarrantStatus;
    startingKm!: number | undefined;
    endingKm!: number | undefined;
    data!: any | undefined;
    compositionId!: number;
    composition!: CompositionDto;
    driverJobPositionIds!: number[] | undefined;
    transportWarrantItems!: TransportWarrantItemDto[] | undefined;

    constructor(data?: ITransportWarrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.isTwFinished = _data["isTwFinished"];
            this.estStartingTime = _data["estStartingTime"] ? new Date(_data["estStartingTime"].toString()) : <any>undefined;
            this.estEndingTime = _data["estEndingTime"] ? new Date(_data["estEndingTime"].toString()) : <any>undefined;
            this.actStartingTime = _data["actStartingTime"] ? new Date(_data["actStartingTime"].toString()) : <any>undefined;
            this.actEndingTime = _data["actEndingTime"] ? new Date(_data["actEndingTime"].toString()) : <any>undefined;
            this.transportWarrantStatus = _data["transportWarrantStatus"];
            this.startingKm = _data["startingKm"];
            this.endingKm = _data["endingKm"];
            this.data = _data["data"];
            this.compositionId = _data["compositionId"];
            this.composition = _data["composition"] ? CompositionDto.fromJS(_data["composition"]) : <any>undefined;
            if (Array.isArray(_data["driverJobPositionIds"])) {
                this.driverJobPositionIds = [] as any;
                for (let item of _data["driverJobPositionIds"])
                    this.driverJobPositionIds!.push(item);
            }
            if (Array.isArray(_data["transportWarrantItems"])) {
                this.transportWarrantItems = [] as any;
                for (let item of _data["transportWarrantItems"])
                    this.transportWarrantItems!.push(TransportWarrantItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransportWarrantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportWarrantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["isTwFinished"] = this.isTwFinished;
        data["estStartingTime"] = this.estStartingTime ? this.estStartingTime.toISOString() : <any>undefined;
        data["estEndingTime"] = this.estEndingTime ? this.estEndingTime.toISOString() : <any>undefined;
        data["actStartingTime"] = this.actStartingTime ? this.actStartingTime.toISOString() : <any>undefined;
        data["actEndingTime"] = this.actEndingTime ? this.actEndingTime.toISOString() : <any>undefined;
        data["transportWarrantStatus"] = this.transportWarrantStatus;
        data["startingKm"] = this.startingKm;
        data["endingKm"] = this.endingKm;
        data["data"] = this.data;
        data["compositionId"] = this.compositionId;
        data["composition"] = this.composition ? this.composition.toJSON() : <any>undefined;
        if (Array.isArray(this.driverJobPositionIds)) {
            data["driverJobPositionIds"] = [];
            for (let item of this.driverJobPositionIds)
                data["driverJobPositionIds"].push(item);
        }
        if (Array.isArray(this.transportWarrantItems)) {
            data["transportWarrantItems"] = [];
            for (let item of this.transportWarrantItems)
                data["transportWarrantItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransportWarrantDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    isTwFinished: boolean;
    estStartingTime: Date;
    estEndingTime: Date;
    actStartingTime: Date;
    actEndingTime: Date;
    transportWarrantStatus: TransportWarrantStatus;
    startingKm: number | undefined;
    endingKm: number | undefined;
    data: any | undefined;
    compositionId: number;
    composition: CompositionDto;
    driverJobPositionIds: number[] | undefined;
    transportWarrantItems: TransportWarrantItemDto[] | undefined;
}

export class TransportWarrantItemDto implements ITransportWarrantItemDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    transportWarrantId!: number;
    shipmentId!: number;
    shipment!: ShipmentDto;

    constructor(data?: ITransportWarrantItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.transportWarrantId = _data["transportWarrantId"];
            this.shipmentId = _data["shipmentId"];
            this.shipment = _data["shipment"] ? ShipmentDto.fromJS(_data["shipment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransportWarrantItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportWarrantItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["transportWarrantId"] = this.transportWarrantId;
        data["shipmentId"] = this.shipmentId;
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransportWarrantItemDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    transportWarrantId: number;
    shipmentId: number;
    shipment: ShipmentDto | undefined;
}

export enum TransportWarrantStatus {
    Idle = "Idle",
    Service = "Service",
    Transport = "Transport",
    Inactive = "Inactive",
}

export class TravelWarrantDto implements ITravelWarrantDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    isTwFinished!: boolean;
    estStartingTime!: Date;
    estEndingTime!: Date;
    actStartingTime!: Date;
    actEndingTime!: Date;
    transportWarrantStatus!: TransportWarrantStatus;
    startingKm!: number | undefined;
    endingKm!: number | undefined;
    data!: any | undefined;
    carId!: number;

    constructor(data?: ITravelWarrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.isTwFinished = _data["isTwFinished"];
            this.estStartingTime = _data["estStartingTime"] ? new Date(_data["estStartingTime"].toString()) : <any>undefined;
            this.estEndingTime = _data["estEndingTime"] ? new Date(_data["estEndingTime"].toString()) : <any>undefined;
            this.actStartingTime = _data["actStartingTime"] ? new Date(_data["actStartingTime"].toString()) : <any>undefined;
            this.actEndingTime = _data["actEndingTime"] ? new Date(_data["actEndingTime"].toString()) : <any>undefined;
            this.transportWarrantStatus = _data["transportWarrantStatus"];
            this.startingKm = _data["startingKm"];
            this.endingKm = _data["endingKm"];
            this.data = _data["data"];
            this.carId = _data["carId"];
        }
    }

    static fromJS(data: any): TravelWarrantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelWarrantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["isTwFinished"] = this.isTwFinished;
        data["estStartingTime"] = this.estStartingTime ? this.estStartingTime.toISOString() : <any>undefined;
        data["estEndingTime"] = this.estEndingTime ? this.estEndingTime.toISOString() : <any>undefined;
        data["actStartingTime"] = this.actStartingTime ? this.actStartingTime.toISOString() : <any>undefined;
        data["actEndingTime"] = this.actEndingTime ? this.actEndingTime.toISOString() : <any>undefined;
        data["transportWarrantStatus"] = this.transportWarrantStatus;
        data["startingKm"] = this.startingKm;
        data["endingKm"] = this.endingKm;
        data["data"] = this.data;
        data["carId"] = this.carId;
        return data;
    }
}

export interface ITravelWarrantDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    isTwFinished: boolean;
    estStartingTime: Date;
    estEndingTime: Date;
    actStartingTime: Date;
    actEndingTime: Date;
    transportWarrantStatus: TransportWarrantStatus;
    startingKm: number | undefined;
    endingKm: number | undefined;
    data: any | undefined;
    carId: number;
}

export class TruckDto implements ITruckDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    amortisation!: number;
    depreciationPeriod!: number;
    productionDate!: Date;
    data!: any | undefined;
    isDeleted!: boolean;
    engineType!: EngineType;
    truckType!: TruckType;
    loadWeight!: number;
    loadVolume!: number;
    loadPalletSpaces!: number;

    constructor(data?: ITruckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.amortisation = _data["amortisation"];
            this.depreciationPeriod = _data["depreciationPeriod"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.isDeleted = _data["isDeleted"];
            this.engineType = _data["engineType"];
            this.truckType = _data["truckType"];
            this.loadWeight = _data["loadWeight"];
            this.loadVolume = _data["loadVolume"];
            this.loadPalletSpaces = _data["loadPalletSpaces"];
        }
    }

    static fromJS(data: any): TruckDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["amortisation"] = this.amortisation;
        data["depreciationPeriod"] = this.depreciationPeriod;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["isDeleted"] = this.isDeleted;
        data["engineType"] = this.engineType;
        data["truckType"] = this.truckType;
        data["loadWeight"] = this.loadWeight;
        data["loadVolume"] = this.loadVolume;
        data["loadPalletSpaces"] = this.loadPalletSpaces;
        return data;
    }
}

export interface ITruckDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    amortisation: number;
    depreciationPeriod: number;
    productionDate: Date;
    data: any | undefined;
    isDeleted: boolean;
    engineType: EngineType;
    truckType: TruckType;
    loadWeight: number;
    loadVolume: number;
    loadPalletSpaces: number;
}

export enum TruckType {
    PickUp = "PickUp",
    Van = "Van",
    RegularTruck = "RegularTruck",
    SemiTrailerTruck = "SemiTrailerTruck",
}

export class UnauthorizedRequestResponse implements IUnauthorizedRequestResponse {
    readonly messageCode!: string | undefined;
    readonly messageValue!: string | undefined;

    constructor(data?: IUnauthorizedRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).messageCode = _data["messageCode"];
            (<any>this).messageValue = _data["messageValue"];
        }
    }

    static fromJS(data: any): UnauthorizedRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnauthorizedRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageCode"] = this.messageCode;
        data["messageValue"] = this.messageValue;
        return data;
    }
}

export interface IUnauthorizedRequestResponse {
    messageCode: string | undefined;
    messageValue: string | undefined;
}

export enum UnitType {
    Length = "Length",
    Angle = "Angle",
}

export enum Urgency {
    Critical = "Critical",
    Major = "Major",
    Medium = "Medium",
    Minor = "Minor",
}

export class UserGroupDto implements IUserGroupDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    name!: string | undefined;
    membersIds!: number[] | undefined;
    userGroupType!: UserGroupType;
    data!: any | undefined;

    constructor(data?: IUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["membersIds"])) {
                this.membersIds = [] as any;
                for (let item of _data["membersIds"])
                    this.membersIds!.push(item);
            }
            this.userGroupType = _data["userGroupType"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.membersIds)) {
            data["membersIds"] = [];
            for (let item of this.membersIds)
                data["membersIds"].push(item);
        }
        data["userGroupType"] = this.userGroupType;
        data["data"] = this.data;
        return data;
    }
}

export interface IUserGroupDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    name: string | undefined;
    membersIds: number[] | undefined;
    userGroupType: UserGroupType;
    data: any | undefined;
}

export enum UserGroupType {
    Predefined = "Predefined",
    Custom = "Custom",
}

export enum UserScope {
    Personal = "Personal",
    Group = "Group",
}

export class VariableAngle implements IVariableAngle {
    refType!: ParameterRefType;
    value!: string | undefined;
    offsetType!: AngleOffsetType;

    constructor(data?: IVariableAngle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refType = _data["refType"];
            this.value = _data["value"];
            this.offsetType = _data["offsetType"];
        }
    }

    static fromJS(data: any): VariableAngle {
        data = typeof data === 'object' ? data : {};
        let result = new VariableAngle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refType"] = this.refType;
        data["value"] = this.value;
        data["offsetType"] = this.offsetType;
        return data;
    }
}

export interface IVariableAngle {
    refType: ParameterRefType;
    value: string | undefined;
    offsetType: AngleOffsetType;
}

export class VariableLength implements IVariableLength {
    refType!: ParameterRefType;
    value!: string | undefined;

    constructor(data?: IVariableLength) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refType = _data["refType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VariableLength {
        data = typeof data === 'object' ? data : {};
        let result = new VariableLength();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refType"] = this.refType;
        data["value"] = this.value;
        return data;
    }
}

export interface IVariableLength {
    refType: ParameterRefType;
    value: string | undefined;
}

export enum VariableType {
    Referent = "Referent",
    Embedded = "Embedded",
}

export class VehicleDocumentDto implements IVehicleDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    vehicleId!: number;

    constructor(data?: IVehicleDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    vehicleId: number;
}

export class VehicleDto implements IVehicleDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    chassisNumber!: string | undefined;
    licensePlateNum!: string | undefined;
    amortisation!: number;
    depreciationPeriod!: number;
    isDeleted!: boolean;
    productionDate!: Date;
    data!: any | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlateNum = _data["licensePlateNum"];
            this.amortisation = _data["amortisation"];
            this.depreciationPeriod = _data["depreciationPeriod"];
            this.isDeleted = _data["isDeleted"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlateNum"] = this.licensePlateNum;
        data["amortisation"] = this.amortisation;
        data["depreciationPeriod"] = this.depreciationPeriod;
        data["isDeleted"] = this.isDeleted;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IVehicleDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    chassisNumber: string | undefined;
    licensePlateNum: string | undefined;
    amortisation: number;
    depreciationPeriod: number;
    isDeleted: boolean;
    productionDate: Date;
    data: any | undefined;
}

export class VehicleExpenseDto implements IVehicleExpenseDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    price!: number;
    liters!: number | undefined;
    pricePerLiter!: number | undefined;
    expenseKm!: number | undefined;
    expenseTypeId!: number | undefined;
    expenseType!: ExpenseTypeDto;
    vehicleId!: number;

    constructor(data?: IVehicleExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.price = _data["price"];
            this.liters = _data["liters"];
            this.pricePerLiter = _data["pricePerLiter"];
            this.expenseKm = _data["expenseKm"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseType = _data["expenseType"] ? ExpenseTypeDto.fromJS(_data["expenseType"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["liters"] = this.liters;
        data["pricePerLiter"] = this.pricePerLiter;
        data["expenseKm"] = this.expenseKm;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleExpenseDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    price: number;
    liters: number | undefined;
    pricePerLiter: number | undefined;
    expenseKm: number | undefined;
    expenseTypeId: number | undefined;
    expenseType: ExpenseTypeDto;
    vehicleId: number;
}

export class VehicleRecordDto implements IVehicleRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    vehicleId!: number;

    constructor(data?: IVehicleRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): VehicleRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IVehicleRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    vehicleId: number;
}

export class WorkingMachineDto implements IWorkingMachineDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    nickname!: string | undefined;
    chassisNumber!: string | undefined;
    machineType!: MachineType;
    productionDate!: Date;
    data!: any | undefined;
    engineType!: EngineType;

    constructor(data?: IWorkingMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.nickname = _data["nickname"];
            this.chassisNumber = _data["chassisNumber"];
            this.machineType = _data["machineType"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): WorkingMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["nickname"] = this.nickname;
        data["chassisNumber"] = this.chassisNumber;
        data["machineType"] = this.machineType;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface IWorkingMachineDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    nickname: string | undefined;
    chassisNumber: string | undefined;
    machineType: MachineType;
    productionDate: Date;
    data: any | undefined;
    engineType: EngineType;
}

export class WorkingToolDocumentDto implements IWorkingToolDocumentDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    category!: string | undefined;
    requestPaths!: string[] | undefined;
    data!: any | undefined;
    workingToolId!: number;

    constructor(data?: IWorkingToolDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.category = _data["category"];
            if (Array.isArray(_data["requestPaths"])) {
                this.requestPaths = [] as any;
                for (let item of _data["requestPaths"])
                    this.requestPaths!.push(item);
            }
            this.data = _data["data"];
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["category"] = this.category;
        if (Array.isArray(this.requestPaths)) {
            data["requestPaths"] = [];
            for (let item of this.requestPaths)
                data["requestPaths"].push(item);
        }
        data["data"] = this.data;
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolDocumentDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    category: string | undefined;
    requestPaths: string[] | undefined;
    data: any | undefined;
    workingToolId: number;
}

export class WorkingToolDto implements IWorkingToolDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    documents!: DocumentDto[] | undefined;
    id!: number;
    manufacturer!: string | undefined;
    model!: string | undefined;
    nickname!: string | undefined;
    chassisNumber!: string | undefined;
    machineType!: MachineType;
    productionDate!: Date;
    data!: any | undefined;

    constructor(data?: IWorkingToolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.nickname = _data["nickname"];
            this.chassisNumber = _data["chassisNumber"];
            this.machineType = _data["machineType"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): WorkingToolDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["nickname"] = this.nickname;
        data["chassisNumber"] = this.chassisNumber;
        data["machineType"] = this.machineType;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IWorkingToolDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    documents: DocumentDto[] | undefined;
    id: number;
    manufacturer: string | undefined;
    model: string | undefined;
    nickname: string | undefined;
    chassisNumber: string | undefined;
    machineType: MachineType;
    productionDate: Date;
    data: any | undefined;
}

export class WorkingToolExpenseDto implements IWorkingToolExpenseDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    price!: number;
    liters!: number | undefined;
    pricePerLiter!: number | undefined;
    expenseKm!: number | undefined;
    expenseTypeId!: number | undefined;
    expenseType!: ExpenseTypeDto;
    workingToolId!: number;

    constructor(data?: IWorkingToolExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.price = _data["price"];
            this.liters = _data["liters"];
            this.pricePerLiter = _data["pricePerLiter"];
            this.expenseKm = _data["expenseKm"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseType = _data["expenseType"] ? ExpenseTypeDto.fromJS(_data["expenseType"]) : <any>undefined;
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["liters"] = this.liters;
        data["pricePerLiter"] = this.pricePerLiter;
        data["expenseKm"] = this.expenseKm;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolExpenseDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    price: number;
    liters: number | undefined;
    pricePerLiter: number | undefined;
    expenseKm: number | undefined;
    expenseTypeId: number | undefined;
    expenseType: ExpenseTypeDto;
    workingToolId: number;
}

export class WorkingToolRecordDto implements IWorkingToolRecordDto {
    created!: Date;
    createdBy!: string | undefined;
    timestamp!: string | undefined;
    modified!: Date | undefined;
    modifiedBy!: string | undefined;
    id!: number;
    validFrom!: Date;
    title!: string | undefined;
    description!: string | undefined;
    category!: RecordCategory;
    documents!: DocumentDto[] | undefined;
    workingToolId!: number;

    constructor(data?: IWorkingToolRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.timestamp = _data["timestamp"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.workingToolId = _data["workingToolId"];
        }
    }

    static fromJS(data: any): WorkingToolRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingToolRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["timestamp"] = this.timestamp;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["workingToolId"] = this.workingToolId;
        return data;
    }
}

export interface IWorkingToolRecordDto {
    created: Date;
    createdBy: string | undefined;
    timestamp: string | undefined;
    modified: Date | undefined;
    modifiedBy: string | undefined;
    id: number;
    validFrom: Date;
    title: string | undefined;
    description: string | undefined;
    category: RecordCategory;
    documents: DocumentDto[] | undefined;
    workingToolId: number;
}

// export interface File {
//     data: any;
//     fileName: string;
// }

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
